// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:32:55.589Z
// Property: Phillips Pass (ID: 5091000275959808)
// Collections: 22 amenities, 4 floorplans (live), 28 photos, 80 POIs, 3 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5091000275959808",
  "property_external_id": "5056159",
  "property_zillow_url": "https://www.zillow.com/b/2323-eldridge-pkwy-s-houston-tx-5XkBgR/",
  "property_apartments_url": "https://www.apartments.com/phillips-pass-houston-tx/5c8nbzn",
  "property_google_business_url": "https://www.google.com/maps/place/Phillips+Pass+Apartments/data=!4m2!3m1!1s0x0:0xd7482820a2677e0f?sa=X&ved=2ahUKEwja9-ixxbySAxVLLbkGHdxUICgQ_BJ6BAgMEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/pulse/houston-rental-application-requirements-your-complete-tom-tran-mm1lc#:~:text=Employment%20History%20Be%20prepared%20to,range%20from%20$30%20to%20$75.",
  "property_hubspot_id": "9835676774",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "phillips-pass",
  "property_name": "Phillips Pass",
  "property_website_url": "https://www.phillipspass.com/",
  "property_domain": "https://www.phillipspass.com/",
  "property_address": "2323 Eldridge Pkwy",
  "property_full_address": "2323 Eldridge Pkwy, Houston, TX 77077",
  "property_address_1": "2323 Eldridge Pkwy",
  "property_address_2": null,
  "property_address_city": "Houston",
  "property_address_state": "TX",
  "property_address_zip_full": "77077-5257",
  "property_address_zip": "77077",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Westside",
  "property_address_latitude": "29.7408675",
  "property_address_longitude": "-95.62289369999999",
  "property_email": "phillipspass@alapts.com",
  "property_phone": "(281) 759-4064",
  "property_call_tracking_phone": "346-521-5069",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Upscale comfort in Briar Village.</strong> Spacious one- and two-bedroom apartments pair polished finishes with everyday ease—then extend home with resort-inspired amenities on Eldridge Parkway. Browse <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> of Phillips Pass today.</p>",
  "property_long_description": "<p><strong>Upscale comfort in Briar Village.</strong> At Phillips Pass, you get West Houston apartment living with space to settle in and details that work hard every day. Choose from one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> with stainless steel appliances, custom cabinetry, premium countertops, full-size washers and dryers, generous walk-in closets, private patios or balconies, and select wood-burning fireplaces.</p><p>Beyond your front door, the community brings together a resort-inspired pool with cabana seating, a state-of-the-art fitness center, resident clubhouse with WFH business center, package lockers, EV charging, and a bark park. When you’re ready to head out, your Eldridge Parkway location places you near Energy Corridor employers, Terry Hershey Park trails, George Bush Park, Ray Miller Park, and everyday dining along Eldridge and Briar Forest—from Sylvia’s Enchilada Kitchen and BB’s Tex-Orleans to Resilience Viet Kitchen, Wula Buhuan, and Topgolf. Explore more local highlights on the <a href=\"/neighborhood\">neighborhood</a> page or browse the <a href=\"/amenities\">amenities</a> that make home feel easy.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019d02ee-06fd-72fa-8ceb-78a43340da9c.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
    "public_id": "019d02ee-06fd-72fa-8ceb-78a43340da9c",
    "storage_key": "property/5091000275959808/019d02ee-06fd-72fa-8ceb-78a43340da9c.webp",
    "width": 1920,
    "height": 1438
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "168",
  "property_year_built": "1997",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.26190476190477",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $25 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8943831.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://phillipspass.loftliving.com/login",
  "property_apply_now_url": "https://8943831.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e7010-eb83-7383-89dc-5ff12bea220d.webp",
  "property_primary_logo_media": {
    "alt_text": "Phillips Pass Apartment Homes logo with Houston Texas text",
    "public_id": "019e7010-eb83-7383-89dc-5ff12bea220d",
    "storage_key": "property/5091000275959808/019e7010-eb83-7383-89dc-5ff12bea220d.webp",
    "width": 607,
    "height": 341
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019d02ef-39e6-7153-9f04-d7164f8e8a6c.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ef-39e6-7153-9f04-d7164f8e8a6c",
    "storage_key": "property/5091000275959808/019d02ef-39e6-7153-9f04-d7164f8e8a6c.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e7012-317f-760d-8fa3-2913e16ae75f.webp",
  "property_icon_media": {
    "alt_text": "Phillips Pass logo",
    "public_id": "019e7012-317f-760d-8fa3-2913e16ae75f",
    "storage_key": "property/5091000275959808/019e7012-317f-760d-8fa3-2913e16ae75f.webp",
    "width": 578,
    "height": 307
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e7012-317f-760d-8fa3-2913e16ae75f.webp",
  "property_fav_icon_media": {
    "alt_text": "Phillips Pass logo",
    "public_id": "019e7012-317f-760d-8fa3-2913e16ae75f",
    "storage_key": "property/5091000275959808/019e7012-317f-760d-8fa3-2913e16ae75f.webp",
    "width": 578,
    "height": 307
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e7011-1298-72d2-94de-90b7da605ca9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Phillips Pass Apartment Homes logo",
    "public_id": "019e7011-1298-72d2-94de-90b7da605ca9",
    "storage_key": "property/5091000275959808/019e7011-1298-72d2-94de-90b7da605ca9.webp",
    "width": 607,
    "height": 341
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e7012-971e-72b8-9ace-07a9e9541eb6.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Phillips Pass Apartment Homes logo",
    "public_id": "019e7012-971e-72b8-9ace-07a9e9541eb6",
    "storage_key": "property/5091000275959808/019e7012-971e-72b8-9ace-07a9e9541eb6.webp",
    "width": 607,
    "height": 342
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#093d52",
  "property_secondary_color": "#45859e",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#45859e",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "708 - 1148",
  "property_sqft_min": "708",
  "property_sqft_max": "1148",
  "property_price_range": "995.66 - 1515",
  "property_price_min": "995.66",
  "property_price_max": "1515",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/PhillipsPassApartments",
  "property_instagram_url": "https://www.instagram.com/phillipspassapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ3yhukGrcQIYRD35noiAoSNc",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/phillips-pass-houston",
  "property_tiktok_url": "https://www.tiktok.com/@phillipspassapts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday ease, resort-inspired moments.</strong> Phillips Pass pairs practical perks like controlled access, parcel lockers, EV charging, door-to-door trash pickup, and online resident services with spaces made to recharge: a clubhouse with WFH business center, conference rooms, fitness center, pool, cabana, sundeck, grilling areas, and pet play area. Inside, enjoy stainless steel appliances, full-size washers and dryers, custom cabinetry, walk-in closets, garden-style tubs, and select private patios or balconies.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with space where it counts.</strong> Choose from one-bedroom layouts with extra breathing room or two-bedroom, two-bath homes with separation for work, guests, storage, and daily routines. Full-size washers and dryers, walk-in closets, kitchen pantries, premium countertops, custom cabinetry, and private patios or balconies in many homes keep life running smoothly, while select plans add fireplaces, island kitchens, built-in bookshelves, or first-floor convenience.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Phillips Pass.</strong> Preview a sunlit clubhouse with bold accent walls, a palm-framed pool with lounge seating, and a fitness space with room to move. Inside, bright kitchens with white cabinetry and stainless steel appliances meet inviting living areas, generous closets, and private outdoor spaces. Browse the gallery, then explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_home_neighborhood_blurb": "<p><strong>West Houston, mapped around you.</strong> From Phillips Pass, grab coffee or dinner along Eldridge Parkway, check off errands at The Commons at the Parkway, and explore Briar Forest favorites like Wula Buhuan and Russo’s New York Pizzeria. Terry Hershey Park and Energy Corridor trails add miles of green space nearby, while METRO stops and routes to I-10, Westheimer, and Westpark Tollway keep the rest of Houston within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say Phillips Pass feels easy to come home to.</strong> Reviews call out updated appliances, spacious living areas, and a clean, quiet atmosphere in Briar Village. Helpful office support and responsive maintenance also stand out, with residents describing the team as professional, personable, and focused on making everyday living smoother.</p>",
  "property_neighborhood_blurb": "<p><strong>Map your day from Briar Village.</strong> At Phillips Pass, West Houston feels refreshingly connected: pick up coffee or dinner along Eldridge Parkway, run quick errands at The Commons at the Parkway, or head toward Briar Forest for local favorites like Wula Buhuan and Russo’s New York Pizzeria. When you want more open air, Terry Hershey Park’s bayou trails and the wider Energy Corridor park network put miles of green space within easy reach.</p><p>Here, neighborhood living is practical without feeling one-note—near everyday shopping, METRO stops along Eldridge and Briar Forest, and major routes toward I-10, Westheimer, Westpark Tollway, and the Energy Corridor. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Phillips Pass fits into your Houston routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living, built around your routine.</strong> At Phillips Pass, convenience is woven into the day with controlled access, parcel lockers, door-to-door trash pickup, EV charging, online resident services, and on-site management and maintenance. Work when you need to in the resident clubhouse with WFH business center and conference rooms, then reset by the resort-inspired pool, cabana, sundeck, grilling and picnic areas, fitness center, or pet play area.</p><p>Inside your Houston apartment, polished finishes and practical details make home feel effortless: full-size washers and dryers, stainless steel appliances, custom cabinetry, premium countertops, generous walk-in closets, garden-style tubs, and private patios or balconies in select homes. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the amenities come together at Phillips Pass.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Phillips Pass.</strong> Choose a one- or two-bedroom apartment with upscale finishes like stainless steel appliances, custom cabinetry, premium countertops, full-size washers and dryers, and generous walk-in closets—then enjoy West Houston living designed to feel easy from day one.</p>",
  "property_contactus_blurb": "<p><strong>Have questions about Phillips Pass?</strong> Our leasing team is here to help with one- and two-bedroom <a href=\"/floor-plans\">floor plans</a>, upscale finishes, community features, and directions to our Eldridge Parkway location in Briar Village. Reach out today—we’ll help you take the next step toward a tour.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Phillips Pass?</strong> Start here for quick answers on the community, leasing, amenities, and everyday apartment living in West Houston. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you move through the day.</strong> Phillips Pass offers one-bedroom apartments with room to stretch out and two-bedroom, two-bath floor plans that add helpful separation for work, guests, hobbies, or extra storage.</p><p>Inside, everyday details do the heavy lifting: full-size washers and dryers, generous walk-in closets, kitchen pantries, built-in microwaves, premium countertops, custom cabinetry, and private patios or balconies in many homes. Select layouts add character with wood-burning fireplaces, island kitchens, built-in bookshelves, or first-floor convenience.</p><p>Compare your options, check current pricing and availability, then browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite Phillips Pass floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>See Phillips Pass from every angle.</strong> Browse photos that bring the community into focus: a sunlit clubhouse with bold accent walls, a sparkling pool framed by palms and lounge seating, and a fitness space with room to move. Inside the apartments, look for bright kitchens with white cabinetry and stainless steel appliances, inviting living areas, generous closets, and private outdoor spaces that extend the home beyond four walls.</p><p>Use the gallery to compare finishes, picture the flow of one- and two-bedroom layouts, and get a closer look at the spaces that make this West Houston apartment community feel polished and easy to enjoy. Ready to keep exploring? View the <a href=\"/amenities\">community amenities</a>, step through <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Phillips Pass in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Map your next move.</strong> Use the interactive map to explore available apartments at Phillips Pass, then zoom out to see how this Eldridge Parkway address connects you to West Houston dining, parks, trails, and Energy Corridor destinations.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, play, and settle in.</strong> At Phillips Pass, pet-friendly living starts with cats and dogs welcome—with up to two pets per home and no weight limit—so your space can fit the companion you already love. Step out for fresh air at the community bark park, take a stroll through the courtyard, or unwind at home on a private patio or balcony available in select apartments.</p><p>Everyday pet care feels simple here, too, with grooming, boarding, training, and veterinary options nearby along Eldridge Parkway. See more community conveniences on the <a href=\"/amenities\">amenities page</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to explore pet-friendly apartments in Houston at Phillips Pass.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Phillips Pass?</strong> Share the upscale comfort, everyday ease, and West Houston convenience with a friend. From spacious one- and two-bedroom floor plans to thoughtful finishes and community spaces that make home feel simple, it’s easy to invite them to see what makes this address worth sharing.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Phillips Pass.</strong><br>Keep everyday apartment living easy from your resident portal. Pay rent, submit maintenance requests, and manage your account in one convenient place—so you can get back to enjoying upscale comfort in Briar Village.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents appreciate about Phillips Pass.</strong> As you read the reviews below, you’ll see consistent praise for updated appliances, roomy living spaces, and a clean, quiet atmosphere.</p><p>Residents also highlight friendly neighbors, helpful office support, and maintenance that makes day-to-day living easier. One longtime resident describes the team as “professional and personable,” while another notes the “clean and large living area.” If you’re comparing apartments in Briar Village, these first-hand reviews offer a grounded look at what living at Phillips Pass can feel like.</p>",
  "property_created_at": "1752256219646",
  "property_scheduletour_blurb": "<p><strong>See upscale comfort up close.</strong> Tour Phillips Pass and picture the everyday ease of stainless steel appliances, custom cabinetry, premium countertops, walk-in closets, and a private patio or balcony—plus community spaces designed for relaxing, working, and recharging. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Phillips Pass.</strong><br>Your submission has been received, and the leasing team will follow up soon. In the meantime, picture West Houston living with spacious one- and two-bedroom layouts, polished in-home finishes, and community spaces designed to make everyday comfort feel easy.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through the spaces before you arrive.</strong> Start with the community video, then move at your own pace through the resident clubhouse with coffee bar, business center, and bright fitness center—spaces where vaulted ceilings, bold teal accents, modern seating, equipment, and natural light are easier to appreciate in motion.</p><p>From there, step inside the A1 and A2 one-bedroom apartment tours to compare the feel of the layouts, from open living areas to kitchens with white cabinetry and stainless steel appliances. Use the virtual tours to narrow your favorites, then browse <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Phillips Pass in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Phillips Pass",
  "property_seo_title_home": "Phillips Pass | Apartments in Houston, TX",
  "property_seo_description_home": "Experience modern living at Phillips Pass in Houston, TX. Explore our thoughtfully designed one and two-bedroom floor plans featuring luxury amenities like a fitness center, pool, and resident clubhouse. Enjoy conveniences like LUXER Package Lockers, walk-in closets, and in-unit W&D. With easy access gates and online resident services, your comfort and security are our top priorities. Find your new home today at Phillips Pass—where style meets convenience!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Houston, TX",
  "property_seo_description_floorplans": "Explore the ideal living space at Phillips Pass in Houston, TX! Choose from our thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Don’t wait – browse our available apartment homes today and find your perfect fit!",
  "property_seo_title_amenities": "Amenities | Houston, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover your ideal home at Phillips Pass in Houston, TX! Explore our spacious one and two-bedroom floor plans featuring tall ceilings, walk-in closets, and modern kitchen appliances. Enjoy a lifestyle of comfort with top-notch amenities including a fitness center, refreshing pool, resident clubhouse, and convenient online services. Enhance your living experience with exclusive access to LUXER Package Lockers, BBQ areas, and secure access gates. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Houston, TX",
  "property_seo_description_gallery": "\"Discover life at Phillips Pass in Houston, TX! Explore our stunning photo gallery showcasing our one and two-bedroom floor plans, featuring modern amenities like a fitness center, resort-style pool, and LUXER Package Locker. Picture yourself enjoying spacious living with tall ceilings, walk-in closets, and beautifully designed kitchens with built-in appliances. Enjoy online resident services and the vibrant community at our resident clubhouse or relax in the outdoor spaces. Embrace the lifestyle you deserve at Phillips Pass—where comfort meets convenience!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Phillips Pass Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Phillips Pass in Houston, TX! Explore our spacious one and two bedroom floor plans with a virtual tour that showcases all our inviting features. Don't miss the opportunity—take a virtual tour of our community and apartments for rent today!",
  "property_seo_title_interactivemap": "Interactive Map | Phillips Pass Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Phillips Pass in Houston, TX! Explore our spacious one and two-bedroom floor plans featuring modern amenities like a fully-equipped fitness center, resort-style pool, and a vibrant resident clubhouse. Enjoy convenient features such as in-unit W&D, pantry closets, and LUXER package lockers. Use our interactive community map to search available apartments, view pricing, and select your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Houston, TX",
  "property_seo_description_neighborhood": "\"Discover the vibrant neighborhood surrounding Phillips Pass in Houston, TX! Explore our diverse floor plans, including spacious one and two-bedroom apartments, while uncovering local favorites and must-visit points of interest. See what's around our community and start your journey today!\"",
  "property_seo_title_contact": "Contact Us | Phillips Pass",
  "property_seo_description_contact": "\"Discover your perfect home at Phillips Pass in Houston, TX. Explore our spacious one and two-bedroom floor plans tailored for your lifestyle. Have questions? Contact our leasing team today and let us help you find your ideal apartment!\"",
  "property_seo_title_faqs": "FAQs | Apartments in Houston, TX",
  "property_seo_description_faqs": "Discover your ideal living space at Phillips Pass in Houston, TX! Explore our diverse floor plans featuring cozy one and two-bedroom options, designed with modern amenities such as LUXER Package Lockers, a state-of-the-art Fitness Center, and a refreshing pool. Enjoy the convenience of online resident services, ample storage with walk-in closets, and beautifully designed kitchens with built-in appliances. Have questions? Browse our FAQs page for quick answers about our vibrant community and make Phillips Pass your new home today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Houston, TX",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at Phillips Pass in Houston, TX! Explore our stunning one and two-bedroom floor plans, equipped with top-notch amenities like a fitness center, pool, and BBQ area. Enjoy the convenience of LUXER package lockers, online resident services, and beautiful walk-in closets. But don’t just take our word for it—see what our residents have to say about their experience living in our welcoming community! Join us at Phillips Pass and experience upscale living today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Houston, TX",
  "property_seo_description_applynow": "Discover your perfect home at Phillips Pass in Houston, TX! Choose from stylish one-bedroom and two-bedroom floor plans featuring modern amenities like a fitness center, pool, and clubhouse. Enjoy the convenience of LUXER package lockers, online resident services, and spacious layouts with walk-in closets and pantry spaces. With 24/7 access gates and top-notch kitchen appliances, comfort and security are just steps away. Find your new home and lease online today—your vibrant community awaits!",
  "property_seo_title_residentaccess": "Resident Access | Phillips Pass",
  "property_seo_description_residentaccess": "\"Log in to the Resident Access Portal at Phillips Pass in Houston, TX! Conveniently pay rent, schedule maintenance, and manage your apartment needs all in one place. Access your account today for a seamless living experience!\"",
  "property_seo_title_referafriend": "Refer A Friend | Phillips Pass",
  "property_seo_description_referafriend": "\"Discover the benefits of living at Phillips Pass in Houston, TX! Refer a friend to our vibrant apartment community today and enjoy exclusive rewards. Great friends make great neighbors—share the experience and enhance your living environment together! Join us now!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Phillips Pass",
  "property_seo_description_scheduletour": "Explore the vibrant lifestyle at Phillips Pass in Houston, TX! Schedule a tour today to discover our stunning apartment features, amenities, and welcoming community. Your ideal home awaits!",
  "property_seo_title_privacy": "Privacy Policy | Phillips Pass",
  "property_seo_description_privacy": "Discover peace of mind at Phillips Pass in Houston, TX. Our privacy policy ensures your personal information is secure and protected. Learn more about how we safeguard your data. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Phillips Pass",
  "property_seo_description_accessibility": "\"Discover Phillips Pass in Houston, TX, where we prioritize accessibility and digital inclusion for all residents. Our commitment to a seamless experience ensures everyone feels at home. Learn more about our accessibility features and how we strive to create an inclusive community. Your comfort is our mission!\"",
  "property_seo_title_sitemap": "Sitemap | Phillips Pass",
  "property_seo_description_sitemap": "\"Discover the ultimate living experience at Phillips Pass in Houston, TX. Explore our comprehensive sitemap to navigate our vibrant apartment community, amenities, and nearby attractions. View our website sitemap today for easy access to all that Phillips Pass has to offer!\"",
  "property_seo_title_thankyou": "Thank You | Phillips Pass",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Phillips Pass in Houston, TX! Your information has been received, and a member of our friendly team will contact you shortly. Explore our vibrant apartment community and discover the perfect home tailored just for you!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Riverview, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320151",
  "amenities": [
    {
      "id": "custom_636ba5fe-29c8-4149-8df0-b0faaf033120",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_41b2b299-92fa-4121-a9fb-e163d6a0dd26",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Entry",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_55b7029a-5cf9-4cfa-abd4-3ee483e05f0c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_274f75f4-51ec-4d5c-b191-13635fcb1290",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "2-Inch Blinds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3ef19bb9-f053-4688-986f-f07c9390e129",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000606",
      "title": "Built-In Microwave",
      "amount": "0.0000",
      "description": "Built-In Microwaves",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_abd0d6f2-4559-4e14-bc04-8ce3c22d47dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Custom Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_48194acc-efb1-4f85-9c0c-b80863a96b5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Car Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ddb13bf7-11d3-4553-bd0a-b8ae6bb52515",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Premium Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f337e1dc-fedc-4fd7-b93e-25baf426b14c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Wood Burning Fireplaces",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c5b33e63-3525-43a5-9742-c5c498718b83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "State-Of-The-Art Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_577054c0-02b8-422f-939d-29b45824330d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1242fed-df29-4d1b-9201-a3f4778f1672",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1b2e297-844b-4fcf-904e-e7e91afd8445",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa97f640-96c4-46bb-b6f5-1c2cd07bd72c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000666",
      "title": "Pantry Closets",
      "amount": "0.0000",
      "description": "Kitchen Pantries",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_01af6cbc-d124-4a0e-b08e-d96b5bbedd19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_daebc7b8-3d86-4a4e-bb97-7f83e07a96e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9` Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6dd0da6c-5cc2-4de8-a54b-1f0165fcc24c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000697",
      "title": "Tubs",
      "amount": "0.0000",
      "description": "Garden Style Tubs",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f4f20083-ab65-4909-a00f-86df2a23f11a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "Full-Size Washer & Dryer",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9238061-ca84-4a5d-b0f8-994d4b3fed23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_70aee7bc-106e-4e17-a081-8b1a72c3eb39",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000001279",
      "title": "BBQ",
      "amount": "0.0000",
      "description": "Picnic Area w/ BBQ Grills",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ca406f2-3466-493f-acf6-379be1add816",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse w/ WFH Business Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_49fe75bd-7d36-4ace-91a3-c0a2f46ae7a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "external_id": "P000002562",
      "title": "Updater",
      "amount": "0.0000",
      "description": "Digital Moving Concierge Services by Updater",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_7887accd-1816-4d52-9b52-d4d827d2d4bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-d78d-715c-a5f1-9c9d43cd4d24.webp",
      "image_media": {
        "alt_text": "Playground equipment in a fenced dog park area with a bench and trees.",
        "public_id": "019e89aa-d78d-715c-a5f1-9c9d43cd4d24",
        "storage_key": "property/5091000275959808/019e89aa-d78d-715c-a5f1-9c9d43cd4d24.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community's dedicated dog park, featuring agility equipment and ample space for your furry friends to play.",
      "link": "",
      "alt_text": "Playground equipment in a fenced dog park area with a bench and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4d70751f-1b90-4d78-80c4-cf73e430464d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-df1f-74dc-9aaf-1b7781efc02d.webp",
      "image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, coffee table, and decorative wall art.",
        "public_id": "019e89aa-df1f-74dc-9aaf-1b7781efc02d",
        "storage_key": "property/5091000275959808/019e89aa-df1f-74dc-9aaf-1b7781efc02d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring a plush sectional sofa, elegant armchair, and a captivating gallery wall.",
      "link": "",
      "alt_text": "Stylish living room with a sectional sofa, armchair, coffee table, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59ef34ec-80f1-4270-9f62-b9608cb07f2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-d038-7027-9e68-9d17c10f9e1e.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with a large fireplace and TV, overlooking an outdoor pool and patio area through large windows.",
        "public_id": "019e89aa-d038-7027-9e68-9d17c10f9e1e",
        "storage_key": "property/5091000275959808/019e89aa-d038-7027-9e68-9d17c10f9e1e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed lounge, featuring a cozy fireplace and ample seating, with stunning views of the resort-style pool.",
      "link": "",
      "alt_text": "Stylish lounge area with a large fireplace and TV, overlooking an outdoor pool and patio area through large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_90cb4940-36b8-4b2e-a9d2-99b303902f4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-d668-71d8-85bd-4cc2ff85d634.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, large mirror, and bathtub/shower combo.",
        "public_id": "019e89aa-d668-71d8-85bd-4cc2ff85d634",
        "storage_key": "property/5091000275959808/019e89aa-d668-71d8-85bd-4cc2ff85d634.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a spacious bathroom featuring a double vanity, ample storage, and a pristine bathtub and shower combination.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, large mirror, and bathtub/shower combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_660f1854-d5fe-427d-9c3e-9afa4f34dcb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-c9c7-74aa-801f-34953f2f01be.webp",
      "image_media": {
        "alt_text": "Courtyard pathway with lush greenery and apartment buildings.",
        "public_id": "019e89aa-c9c7-74aa-801f-34953f2f01be",
        "storage_key": "property/5091000275959808/019e89aa-c9c7-74aa-801f-34953f2f01be.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stroll through the beautifully landscaped courtyards and enjoy the vibrant community spaces at our apartment complex. Experience a peaceful retreat surrounded by nature and modern architecture.",
      "link": "",
      "alt_text": "Courtyard pathway with lush greenery and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_45bc23b8-d25c-48c2-8c31-7a01d2a8fce2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-c998-72b5-a96d-d8c4ce2534e9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, framed by a pergola with two grills and seating areas.",
        "public_id": "019e89aa-c998-72b5-a96d-d8c4ce2534e9",
        "storage_key": "property/5091000275959808/019e89aa-c998-72b5-a96d-d8c4ce2534e9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and outdoor grilling stations, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, framed by a pergola with two grills and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_243bdb38-8f57-4d6e-8d99-94ebe3bc3915",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-c6c6-75a2-8284-5bdd540c79b1.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019e89aa-c6c6-75a2-8284-5bdd540c79b1",
        "storage_key": "property/5091000275959808/019e89aa-c6c6-75a2-8284-5bdd540c79b1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b25dbd76-f870-4066-aea7-9abc9f8e7c32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-c9fb-7389-849c-9cdef978e5b3.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, decorative pillows, and a bedside table.",
        "public_id": "019e89aa-c9fb-7389-849c-9cdef978e5b3",
        "storage_key": "property/5091000275959808/019e89aa-c9fb-7389-849c-9cdef978e5b3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush king-size bed with decorative pillows, a stylish bedside table, and large windows for natural light.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, decorative pillows, and a bedside table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f8c5aeff-eff3-4f1b-80be-5788024d670c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-c73d-759e-8999-972f0d5a921d.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with white cabinets, stainless steel appliances, and a glass-top dining table with white chairs.",
        "public_id": "019e89aa-c73d-759e-8999-972f0d5a921d",
        "storage_key": "property/5091000275959808/019e89aa-c73d-759e-8999-972f0d5a921d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern and spacious kitchen and dining area featuring white cabinetry, stainless steel appliances, a large island, and a stylish dining set, perfect for entertaining.",
      "link": "",
      "alt_text": "Kitchen and dining area with white cabinets, stainless steel appliances, and a glass-top dining table with white chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_df880195-7390-4c40-ab59-80fdec3d6d75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-c8f2-73c9-9de4-8834256f8893.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, grey and white cabinetry, and a large sink.",
        "public_id": "019e89aa-c8f2-73c9-9de4-8834256f8893",
        "storage_key": "property/5091000275959808/019e89aa-c8f2-73c9-9de4-8834256f8893.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and contemporary kitchen featuring stainless steel appliances, ample storage, and a sleek design. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, grey and white cabinetry, and a large sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b3f9676-acb1-4bf4-9629-b470c45f825f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-c3ac-77ed-b1b0-fbef145df01d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with a spa and lounge area.",
        "public_id": "019e89aa-c3ac-77ed-b1b0-fbef145df01d",
        "storage_key": "property/5091000275959808/019e89aa-c3ac-77ed-b1b0-fbef145df01d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with a relaxing spa and ample lounge space for soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with a spa and lounge area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2f25151d-4f5d-405e-a955-352c38bd8b2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-be85-73eb-b1d4-778c66ca8cda.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees in front of apartment buildings.",
        "public_id": "019e89aa-be85-73eb-b1d4-778c66ca8cda",
        "storage_key": "property/5091000275959808/019e89aa-be85-73eb-b1d4-778c66ca8cda.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush palm trees. Enjoy the resort-style amenities at our beautiful apartment community.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and palm trees in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b46361b8-9d01-498c-875b-50493a55ce23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-c12c-7217-b7ee-45266ec3238e.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment.",
        "public_id": "019e89aa-c12c-7217-b7ee-45266ec3238e",
        "storage_key": "property/5091000275959808/019e89aa-c12c-7217-b7ee-45266ec3238e.webp",
        "width": 3072,
        "height": 2054
      },
      "title": "Apartment",
      "description": "View of a modern apartment's living room and kitchen, featuring comfortable seating, a dining area, and a well-equipped kitchen.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23d61129-7894-4ab2-a4cb-d7466c515774",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-abea-77b8-a66f-262897bb44cc.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs, rug, and decorative fire hydrant.",
        "public_id": "019e89aa-abea-77b8-a66f-262897bb44cc",
        "storage_key": "property/5091000275959808/019e89aa-abea-77b8-a66f-262897bb44cc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony, furnished with comfortable seating and a stylish rug. Perfect for relaxing outdoors.",
      "link": "",
      "alt_text": "Balcony with two chairs, rug, and decorative fire hydrant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb4eeabc-a7d2-4906-afda-66ddff0915cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-aa08-71e8-91d6-70eb60688c14.webp",
      "image_media": {
        "alt_text": "Modern living room with a large sectional sofa, TV, and decorative shelves.",
        "public_id": "019e89aa-aa08-71e8-91d6-70eb60688c14",
        "storage_key": "property/5091000275959808/019e89aa-aa08-71e8-91d6-70eb60688c14.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into a beautifully furnished living space, perfect for relaxing or entertaining. This apartment features a stylish sectional, a large wall-mounted TV, and elegant shelving.",
      "link": "",
      "alt_text": "Modern living room with a large sectional sofa, TV, and decorative shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_585c8a69-7330-48a1-922d-b4f8d0a6a9c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-9fbf-75bd-8773-aedd676a0c89.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e89aa-9fbf-75bd-8773-aedd676a0c89",
        "storage_key": "property/5091000275959808/019e89aa-9fbf-75bd-8773-aedd676a0c89.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge seating. Perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dbd459f1-2413-4db1-97ae-787fdc8a301b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-a6cb-7114-bd6d-0bc0bd439413.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with blue and white siding, balconies, and manicured landscaping.",
        "public_id": "019e89aa-a6cb-7114-bd6d-0bc0bd439413",
        "storage_key": "property/5091000275959808/019e89aa-a6cb-7114-bd6d-0bc0bd439413.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Exterior view of the apartment building showcasing its modern design, private balconies, and well-maintained grounds.",
      "link": "",
      "alt_text": "Apartment building exterior with blue and white siding, balconies, and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3818e572-9852-4915-bab6-42ff55b94193",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-a6cf-73f3-a591-a95fad7f92fe.webp",
      "image_media": {
        "alt_text": "Closet with shelves, drawers, and hanging storage.",
        "public_id": "019e89aa-a6cf-73f3-a591-a95fad7f92fe",
        "storage_key": "property/5091000275959808/019e89aa-a6cf-73f3-a591-a95fad7f92fe.webp",
        "width": 2049,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving and hanging space for organized storage.",
      "link": "",
      "alt_text": "Closet with shelves, drawers, and hanging storage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d5af9d46-c3f2-4038-806a-84a8540da914",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-a7c0-76d0-8fdd-0e915e42c236.webp",
      "image_media": {
        "alt_text": "Modern community kitchen area with bar seating and view of pool",
        "public_id": "019e89aa-a7c0-76d0-8fdd-0e915e42c236",
        "storage_key": "property/5091000275959808/019e89aa-a7c0-76d0-8fdd-0e915e42c236.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our stylish community kitchen, perfect for gatherings or a quick coffee break. Features bar seating and a scenic view of the pool area.",
      "link": "",
      "alt_text": "Modern community kitchen area with bar seating and view of pool",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e0480f10-2796-4fb6-8a31-2e7fbf838714",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-9c3e-770d-8210-9e9fd6e8e9de.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge seating and palm trees.",
        "public_id": "019e89aa-9c3e-770d-8210-9e9fd6e8e9de",
        "storage_key": "property/5091000275959808/019e89aa-9c3e-770d-8210-9e9fd6e8e9de.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Take a dip in our sparkling swimming pool, perfect for relaxing and soaking up the sun. Enjoy the resort-style amenities and lush landscaping.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge seating and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e6811595-8ed0-4e06-a5b2-2eba813509e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-9c2e-754e-8150-3140c3f33179.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a plush navy bed, decorative pillows, and modern hanging lights.",
        "public_id": "019e89aa-9c2e-754e-8150-3140c3f33179",
        "storage_key": "property/5091000275959808/019e89aa-9c2e-754e-8150-3140c3f33179.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a luxurious navy blue bed and elegant decor.",
      "link": "",
      "alt_text": "A cozy bedroom with a plush navy bed, decorative pillows, and modern hanging lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0671853d-f8a8-4853-9c5a-9a14be06f9b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-a211-7169-9bab-71c2f57525cd.webp",
      "image_media": {
        "alt_text": "Co-working space with long desk, chairs, and lounge seating.",
        "public_id": "019e89aa-a211-7169-9bab-71c2f57525cd",
        "storage_key": "property/5091000275959808/019e89aa-a211-7169-9bab-71c2f57525cd.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "A modern co-working space featuring a long desk with rolling chairs, comfortable lounge seating, and decorative shelving on a blue accent wall.",
      "link": "",
      "alt_text": "Co-working space with long desk, chairs, and lounge seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e8bda5ea-f948-4699-a1e9-03c328d94cf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-9a3d-75d3-9c68-183b4bade199.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer behind louvered doors.",
        "public_id": "019e89aa-9a3d-75d3-9c68-183b4bade199",
        "storage_key": "property/5091000275959808/019e89aa-9a3d-75d3-9c68-183b4bade199.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer located behind louvered doors, complete with shelving for storage.",
      "link": "",
      "alt_text": "In-unit washer and dryer behind louvered doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21b2d263-72c2-4013-9e8d-00d47122f46f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-8b16-71fa-b444-93169bac5302.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with free weights, weight machines, and cardio equipment.",
        "public_id": "019e89aa-8b16-71fa-b444-93169bac5302",
        "storage_key": "property/5091000275959808/019e89aa-8b16-71fa-b444-93169bac5302.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio machines, weight training equipment, and free weights to help you reach your fitness goals.",
      "link": "",
      "alt_text": "Well-equipped fitness center with free weights, weight machines, and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b4a746cf-be62-45b5-bf0a-ebaedf8d2a5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-8931-770e-91ea-a4ae490d10ee.webp",
      "image_media": {
        "alt_text": "Desk with a laptop, stapler, and decorative items in a home office space.",
        "public_id": "019e89aa-8931-770e-91ea-a4ae490d10ee",
        "storage_key": "property/5091000275959808/019e89aa-8931-770e-91ea-a4ae490d10ee.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "A functional and stylish home office area featuring a desk with a laptop, ample shelving, and a comfortable stool.",
      "link": "",
      "alt_text": "Desk with a laptop, stapler, and decorative items in a home office space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20563e7b-a148-4372-9c92-a301029b7ab7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-8b46-74f9-a6f1-004c49cc3afd.webp",
      "image_media": {
        "alt_text": "Interior of a gym with treadmills, elliptical machines, and weights, overlooking an outdoor pool.",
        "public_id": "019e89aa-8b46-74f9-a6f1-004c49cc3afd",
        "storage_key": "property/5091000275959808/019e89aa-8b46-74f9-a6f1-004c49cc3afd.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring state-of-the-art cardio machines and weight training equipment. Step outside to our sparkling pool after your workout.",
      "link": "",
      "alt_text": "Interior of a gym with treadmills, elliptical machines, and weights, overlooking an outdoor pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_65f93e9c-8b75-47e1-813f-23e8844dadc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-885b-7123-8e16-83ecb15f7988.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast bar with stools.",
        "public_id": "019e89aa-885b-7123-8e16-83ecb15f7988",
        "storage_key": "property/5091000275959808/019e89aa-885b-7123-8e16-83ecb15f7988.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring white shaker cabinets, a sleek stainless steel refrigerator and microwave, and a convenient breakfast bar with three wooden stools. Perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a799ba5b-cb5e-4dbf-b22d-8967aaaff2e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e89aa-8adf-716a-a548-db16bfd8ded8.webp",
      "image_media": {
        "alt_text": "Living room with sofa, TV, and bar stools.",
        "public_id": "019e89aa-8adf-716a-a548-db16bfd8ded8",
        "storage_key": "property/5091000275959808/019e89aa-8adf-716a-a548-db16bfd8ded8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, entertainment center with TV, and a breakfast bar with stools, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with sofa, TV, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_3f8d9fe926c0a6a401039410",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Pecan Creek Grille",
      "poi_type": "Restaurants",
      "poi_address": "1510 Eldridge Pkwy S #100, Houston, TX 77077, USA",
      "poi_short_description": "Counter-serve joint dishing up Southern & Tex-Mex breakfast & lunch in a rustic, Western setting.",
      "poi_long_description": "Counter-serve joint dishing up Southern & Tex-Mex breakfast & lunch in a rustic, Western setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-c91d-775b-b173-1602f6bbb688.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-c91d-775b-b173-1602f6bbb688",
        "storage_key": "property/5091000275959808/019f14fe-c91d-775b-b173-1602f6bbb688.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://pecancreekgrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15785767126804361940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pecan-creek-grille",
      "poi_latitude": "29.7578691",
      "poi_longitude": "-95.6264762",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-759-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR4OFbgvcQIYR1HI2tJBPEts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_92354fddaf36a43fb30f866d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Matsu Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "1531 Eldridge Pkwy #185, Houston, TX 77077, USA",
      "poi_short_description": "Relaxed, contemporary Japanese spot serving sushi & sashimi, plus teriyaki, noodles & bento boxes.",
      "poi_long_description": "Relaxed, contemporary Japanese spot serving sushi & sashimi, plus teriyaki, noodles & bento boxes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-ca5d-714a-adfd-34cef0d6d39b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-ca5d-714a-adfd-34cef0d6d39b",
        "storage_key": "property/5091000275959808/019f14fe-ca5d-714a-adfd-34cef0d6d39b.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "http://www.matsuhouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8678320076549834637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matsu-sushi-bar",
      "poi_latitude": "29.7562658",
      "poi_longitude": "-95.6245259",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-531-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2hhU3PcQIYRjcfkQSGWb3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_d25c9f58804e976f6cfc63b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Rattan Pan Asian bistro & Wine Bar",
      "poi_type": "Restaurants",
      "poi_address": "1396 Eldridge Pkwy Ste A, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-c849-753b-84eb-f64f3a52f9ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-c849-753b-84eb-f64f3a52f9ef",
        "storage_key": "property/5091000275959808/019f14fe-c849-753b-84eb-f64f3a52f9ef.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://rattanpanbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=299820829820086010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rattan-pan-asian-bistro--wine-bar",
      "poi_latitude": "29.7606557",
      "poi_longitude": "-95.6262864",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-556-9888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl7nurILdQIYR-mawyXQtKQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_fusion_restaurant"
    },
    {
      "id": "ec_d61250296d715999d276b9fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Smashburger",
      "poi_type": "Restaurants",
      "poi_address": "1635 Eldridge Pkwy Ste 100, Houston, TX 77077, USA",
      "poi_short_description": "Counter-serve chain featuring signature smashed burgers, plus sides & shakes.",
      "poi_long_description": "Counter-serve chain featuring signature smashed burgers, plus sides & shakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-c8c8-72e2-994e-257727673d60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-c8c8-72e2-994e-257727673d60",
        "storage_key": "property/5091000275959808/019f14fe-c8c8-72e2-994e-257727673d60.webp",
        "width": 1280,
        "height": 727
      },
      "poi_business_url": "https://smashburger.com/locations/us/tx/houston/1635-eldridge-pkwy?utm_medium=organic&utm_source=local&utm_campaign=googlelistings&utm_content=website&utm_term=1013",
      "poi_directions_map_url": "https://maps.google.com/?cid=5949615920742247252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smashburger",
      "poi_latitude": "29.7539008",
      "poi_longitude": "-95.6245159",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-810-4071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13Cw1gzcQIYRVKvZUShIkVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_ebbf7b0851552f35ec023712",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "1120 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-cb83-71e2-9e9d-fabf6f61d866.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-cb83-71e2-9e9d-fabf6f61d866",
        "storage_key": "property/5091000275959808/019f14fe-cb83-71e2-9e9d-fabf6f61d866.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.chipotle.com/tx/houston/1120-eldridge-pkwy?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=2140",
      "poi_directions_map_url": "https://maps.google.com/?cid=385744732530134724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "29.7683755",
      "poi_longitude": "-95.6241177",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-617-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaYUKUvPbQIYRxM5vXMpwWgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_f09f3a40ad2505af703021ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Persis Biryani Indian Grill",
      "poi_type": "Restaurants",
      "poi_address": "1460 Eldridge Pkwy ste#130, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-cf10-73c9-bad0-d2c9ac29f700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-cf10-73c9-bad0-d2c9ac29f700",
        "storage_key": "property/5091000275959808/019f14fe-cf10-73c9-bad0-d2c9ac29f700.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.persisbiryanihouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12049858236395387957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "persis-biryani-indian-grill",
      "poi_latitude": "29.7592348",
      "poi_longitude": "-95.6259407",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-534-3813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG31pcCDbQIYRNXwpHjmyOac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "ec_7cb304096bf9488649029955",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "la Madeleine",
      "poi_type": "Restaurants",
      "poi_address": "1560 Eldridge Pkwy Ste 190, Houston, TX 77077, USA",
      "poi_short_description": "Quaint French cafe chain serving rustic country fare, espresso & fresh-baked baguettes.",
      "poi_long_description": "Quaint French cafe chain serving rustic country fare, espresso & fresh-baked baguettes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-ce9d-76fe-a643-53fd4c27570a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-ce9d-76fe-a643-53fd4c27570a",
        "storage_key": "property/5091000275959808/019f14fe-ce9d-76fe-a643-53fd4c27570a.webp",
        "width": 1280,
        "height": 916
      },
      "poi_business_url": "https://lamadeleine.com/locations/houston-parkway-village",
      "poi_directions_map_url": "https://maps.google.com/?cid=16813351327504930421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-madeleine",
      "poi_latitude": "29.7561329",
      "poi_longitude": "-95.6279256",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-760-4134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Tc1mwvcQIYRdRbGj_MFVek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_6303371c031ec12b7dcf24d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "BB's Tex-Orleans",
      "poi_type": "Restaurants",
      "poi_address": "1275 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "Local Tex-Orleans chain serving po' boys, gumbo, fried seafood & more in a casual setting.",
      "poi_long_description": "Local Tex-Orleans chain serving po' boys, gumbo, fried seafood & more in a casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-ca5b-702d-841c-1efe961fb827.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-ca5b-702d-841c-1efe961fb827",
        "storage_key": "property/5091000275959808/019f14fe-ca5b-702d-841c-1efe961fb827.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://bbstexorleans.com/locations/energy-corridor/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15858160931776523372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bbs-tex-orleans",
      "poi_latitude": "29.7638323",
      "poi_longitude": "-95.6246933",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 832-263-6644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPcrUtIrbQIYRbGyE6ViBE9w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "ec_7d3be26c2cc4ec95d3358a34",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Tropical Smoothie Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1531 Eldridge Pkwy Unit 140, Houston, TX 77077, USA",
      "poi_short_description": "Health-conscious cafe chain featuring a menu of custom smoothies, sandwiches & wraps.",
      "poi_long_description": "Health-conscious cafe chain featuring a menu of custom smoothies, sandwiches & wraps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-cb12-753e-94a0-f185483e59c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-cb12-753e-94a0-f185483e59c7",
        "storage_key": "property/5091000275959808/019f14fe-cb12-753e-94a0-f185483e59c7.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://locations.tropicalsmoothiecafe.com/tx/houston/1531-elridge-pkwy?y_source=1_MTIxMTY5ODktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14080648007517655534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tropical-smoothie-cafe",
      "poi_latitude": "29.756434",
      "poi_longitude": "-95.62452",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-496-2233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLf3mr-HdQIYR7tFmp8KCaMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "juice_shop"
    },
    {
      "id": "ec_1149bc2e551ac3ac07497c65",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Hummus Republic",
      "poi_type": "Restaurants",
      "poi_address": "1635 Eldridge Pkwy #200, Houston, TX 77077, USA",
      "poi_short_description": "Relaxed, clean eatery specializing in build-your-own bowls, wraps and pitas, as well as falafel and shawarma.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-cf4e-72c8-8ebf-4c33625d63d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-cf4e-72c8-8ebf-4c33625d63d2",
        "storage_key": "property/5091000275959808/019f14fe-cf4e-72c8-8ebf-4c33625d63d2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thehummusrepublic.com/our_locations/houston-tx/?utm_source=social&utm_medium=houston-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=17506544655574439470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hummus-republic",
      "poi_latitude": "29.7537552",
      "poi_longitude": "-95.6246159",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 346-635-6030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2xkecb7dQIYRLhYHUJy98_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_c006d3bb56de3e149f09f00f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Wula Buhuan",
      "poi_type": "Restaurants",
      "poi_address": "13346 Briar Forest Dr, Houston, TX 77077, USA",
      "poi_short_description": "Comfortable & vibrant BYOB kitchen dishing up ample selections of modern Sichuan cuisine.",
      "poi_long_description": "Comfortable & vibrant BYOB kitchen dishing up ample selections of modern Sichuan cuisine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-d72a-72d8-b491-f9683bf56a83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-d72a-72d8-b491-f9683bf56a83",
        "storage_key": "property/5091000275959808/019f14fe-d72a-72d8-b491-f9683bf56a83.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://houstonwula.com/?y_source=1_MTE4NDU0OTgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7036032409069172432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wula-buhuan",
      "poi_latitude": "29.7547685",
      "poi_longitude": "-95.622898",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-328-8757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-fEp4NDdQIYR0Da0kjICpWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_0bf1181a6bf8c8a5c873cf01",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "The Derrick Tavern",
      "poi_type": "Restaurants",
      "poi_address": "1127 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "Casual bar & grill with thin-crust pizza, steaks & daily drink specials, plus live country music.",
      "poi_long_description": "Casual bar & grill with thin-crust pizza, steaks & daily drink specials, plus live country music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-d52e-767b-b7a9-08c714f5db47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-d52e-767b-b7a9-08c714f5db47",
        "storage_key": "property/5091000275959808/019f14fe-d52e-767b-b7a9-08c714f5db47.webp",
        "width": 1280,
        "height": 944
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12119983118119374019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-derrick-tavern",
      "poi_latitude": "29.7673778",
      "poi_longitude": "-95.6230013",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-759-4922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-7399-72f8-a635-7b348fc3a7a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-7399-72f8-a635-7b348fc3a7a2",
        "storage_key": "property/5091000275959808/019f14ff-7399-72f8-a635-7b348fc3a7a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZXqZovbQIYRw4w8d27UMqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_70c0623233cbab04c4cff3ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Sayad Mediterranean Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "2712 Eldridge Pkwy, Houston, TX 77082, USA",
      "poi_short_description": "Contemporary eatery offering a wide variety of Mediterranean fare including meats, seafood & kebabs.",
      "poi_long_description": "Contemporary eatery offering a wide variety of Mediterranean fare including meats, seafood & kebabs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-d26f-72cd-b5e6-2337032657e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-d26f-72cd-b5e6-2337032657e6",
        "storage_key": "property/5091000275959808/019f14fe-d26f-72cd-b5e6-2337032657e6.webp",
        "width": 946,
        "height": 894
      },
      "poi_business_url": "https://sayadkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14900685743509307021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sayad-mediterranean-kitchen",
      "poi_latitude": "29.7326884",
      "poi_longitude": "-95.6243975",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-293-9090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ48XTxvPcQIYRjX6Zi7zeyc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "middle_eastern_restaurant"
    },
    {
      "id": "ec_0406f704c5b80313ce9544eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Timewise",
      "poi_type": "Shopping & Retail",
      "poi_address": "1402 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "Chain of gas stations with convenience stores, selling snacks, drinks & sundries.",
      "poi_long_description": "Chain of gas stations with convenience stores, selling snacks, drinks & sundries.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://find.shell.com/us/fuel/10004196-1402-eldridge-pkwy/en_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=13971431872370727679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "timewise",
      "poi_latitude": "29.759523",
      "poi_longitude": "-95.625965",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-759-1255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-7399-72f8-a635-7ed4e1b0f1e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-7399-72f8-a635-7ed4e1b0f1e9",
        "storage_key": "property/5091000275959808/019f14ff-7399-72f8-a635-7ed4e1b0f1e9.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJR2Ha3QrcQIYR_1o6nEN_5ME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_9218175ebcbda1b2a9b131db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "1520 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-d920-72cb-8c5d-1f2fb2d72d72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-d920-72cb-8c5d-1f2fb2d72d72",
        "storage_key": "property/5091000275959808/019f14fe-d920-72cb-8c5d-1f2fb2d72d72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/houston/briar-forest/034/00349?cid=loc_03400349_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=983664066786634561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "29.7574947",
      "poi_longitude": "-95.6274207",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-496-6063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-3152-76bd-ba0f-27ee9a91f400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-3152-76bd-ba0f-27ee9a91f400",
        "storage_key": "property/5091000275959808/019f14fd-3152-76bd-ba0f-27ee9a91f400.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWl8sAzcQIYRQSsiz0Gtpg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_ef3af253f739daa184dff325",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1506 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-d8cc-763e-8f46-e791170c7f4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-d8cc-763e-8f46-e791170c7f4c",
        "storage_key": "property/5091000275959808/019f14fe-d8cc-763e-8f46-e791170c7f4c.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1506+eldridge+pkwy-houston-tx-77077/id=5313",
      "poi_directions_map_url": "https://maps.google.com/?cid=13399161128363175285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.7566096",
      "poi_longitude": "-95.6258156",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-558-4565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZYmUWQvcQIYRdS1P8A1i87k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_1d3cafffd56a1f7d40463986",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700 Eldridge Pkwy, Houston, TX 77082, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-d661-7569-accf-584baf37553f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-d661-7569-accf-584baf37553f",
        "storage_key": "property/5091000275959808/019f14fe-d661-7569-accf-584baf37553f.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/houston-tx-pharmacies/2700-eldridge-pkwy-houston-tx-77082/storeid=17476?WT.mc_id=LS_GOOGLE_RX_17476",
      "poi_directions_map_url": "https://maps.google.com/?cid=2821342438639300871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.7327035",
      "poi_longitude": "-95.6272309",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-810-5252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-73a6-7639-94d1-981654b4945a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-73a6-7639-94d1-981654b4945a",
        "storage_key": "property/5091000275959808/019f14ff-73a6-7639-94d1-981654b4945a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0nYzTjcQIYRB3HU9P9rJyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_1e029aa40e98b32ae1df4554",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Foody's Gourmet",
      "poi_type": "Shopping & Retail",
      "poi_address": "1400 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "French bakery making classics such as baguettes, quiche, croissants & macarons plus custom cakes.",
      "poi_long_description": "French bakery making classics such as baguettes, quiche, croissants & macarons plus custom cakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-d98c-733c-ac73-89cd389b30ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-d98c-733c-ac73-89cd389b30ad",
        "storage_key": "property/5091000275959808/019f14fe-d98c-733c-ac73-89cd389b30ad.webp",
        "width": 1280,
        "height": 939
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10388257039623884193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foodys-gourmet",
      "poi_latitude": "29.7601667",
      "poi_longitude": "-95.6261667",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPTlOwgrcQIYRoY07-ryAKpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_fba8c90505c960c917906502",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "2610 Eldridge Pkwy, Houston, TX 77082, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-e03d-7474-8052-ac4a4a20c93e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-e03d-7474-8052-ac4a4a20c93e",
        "storage_key": "property/5091000275959808/019f14fe-e03d-7474-8052-ac4a4a20c93e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/tx/houston-store1967.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=4605921363916292860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "29.7336184",
      "poi_longitude": "-95.6251599",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-596-0535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314c-734b-819d-098b0822ddd1",
        "storage_key": "property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlU9oukDcQIYR_AKdxxOF6z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_04029d15945e39eea78b53e1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "2618 Eldridge Pkwy B6, Houston, TX 77082, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-dc41-77dd-bbc0-bbf690536470.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-dc41-77dd-bbc0-bbf690536470",
        "storage_key": "property/5091000275959808/019f14fe-dc41-77dd-bbc0-bbf690536470.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dollartree.com/tx/houston/2618-eldridge-parkway-b6?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1684516660816661958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "29.7332711",
      "poi_longitude": "-95.6251344",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 346-613-2630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314c-734b-819d-098b0822ddd1",
        "storage_key": "property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlU9oukDcQIYRxk00YvqaYBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_c195a4e10fa0441e54b90fe0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11683 Westheimer Rd, Houston, TX 77077, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-e54b-763e-a0e7-71766036d18e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-e54b-763e-a0e7-71766036d18e",
        "storage_key": "property/5091000275959808/019f14fe-e54b-763e-a0e7-71766036d18e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/tx/houston/431/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2636626803521818376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "29.7354063",
      "poi_longitude": "-95.5824872",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-496-2488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-3152-76bd-ba0f-27ee9a91f400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-3152-76bd-ba0f-27ee9a91f400",
        "storage_key": "property/5091000275959808/019f14fd-3152-76bd-ba0f-27ee9a91f400.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmb9cC-rcQIYRCA8xvRsulyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_7eb9dcd9a440135fed2354b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700 S Kirkwood Rd, Houston, TX 77077, USA",
      "poi_short_description": "Chain retailer offering a variety of merchandise, including clothing, furniture, and home goods, plus a pharmacy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-e275-717e-a94d-194f8a0888e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-e275-717e-a94d-194f8a0888e3",
        "storage_key": "property/5091000275959808/019f14fe-e275-717e-a94d-194f8a0888e3.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3296-houston-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10566359969610031709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.732948",
      "poi_longitude": "-95.5915974",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-558-5670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314c-734b-819d-098b0822ddd1",
        "storage_key": "property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi4jGXu7cQIYRXWKDzWhAo5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_8aeff702536bc10e6251cf1e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Barbara Bush Elementary School",
      "poi_type": "Education",
      "poi_address": "13800 Westerloch Dr, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-e556-7472-9456-b4d9b99104a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-e556-7472-9456-b4d9b99104a5",
        "storage_key": "property/5091000275959808/019f14fe-e556-7472-9456-b4d9b99104a5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.houstonisd.org/domain/22337",
      "poi_directions_map_url": "https://maps.google.com/?cid=14077886463894777991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barbara-bush-elementary-school",
      "poi_latitude": "29.7595074",
      "poi_longitude": "-95.6326056",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-368-2150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315e-74bc-b594-d12c260cafc6",
        "storage_key": "property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw3jgDgncQIYRh3C6rCazXsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_8a37cd63316d27c5c386b48d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "West Briar Middle School",
      "poi_type": "Education",
      "poi_address": "13733 Brimhurst Dr, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-eb21-777b-b557-6faa8aeebcee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-eb21-777b-b557-6faa8aeebcee",
        "storage_key": "property/5091000275959808/019f14fe-eb21-777b-b557-6faa8aeebcee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.houstonisd.org/westbriar",
      "poi_directions_map_url": "https://maps.google.com/?cid=6171975100768126436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-briar-middle-school",
      "poi_latitude": "29.7604624",
      "poi_longitude": "-95.6297769",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-368-2140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315e-74bc-b594-d12c260cafc6",
        "storage_key": "property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa0Ku0PfbQIYR5AXXU6dCp1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_66262f80e19f8b19cc4b7ae8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Westside High School",
      "poi_type": "Education",
      "poi_address": "14201 Briar Forest Dr, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-f59b-71cd-99d6-bf6500112fc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-f59b-71cd-99d6-bf6500112fc9",
        "storage_key": "property/5091000275959808/019f14fe-f59b-71cd-99d6-bf6500112fc9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.houstonisd.org/westsidehs",
      "poi_directions_map_url": "https://maps.google.com/?cid=5117399222305862051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westside-high-school",
      "poi_latitude": "29.7545326",
      "poi_longitude": "-95.6375044",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-920-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315e-74bc-b594-d12c260cafc6",
        "storage_key": "property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0dp5FAXcQIYRo7Fmw3qnBEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_eb123147dbfb10cb38c1002c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Primrose School of Eldridge Parkway",
      "poi_type": "Education",
      "poi_address": "2150 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-f1f1-74f5-afe4-361f4052c48d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-f1f1-74f5-afe4-361f4052c48d",
        "storage_key": "property/5091000275959808/019f14fe-f1f1-74f5-afe4-361f4052c48d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.primroseschools.com/schools/eldridge-parkway/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=9754915494377581714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-eldridge-parkway",
      "poi_latitude": "29.74364",
      "poi_longitude": "-95.624892",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-589-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315e-74bc-b594-d12c260cafc6",
        "storage_key": "property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw3gCS2vcQIYRkmxUWPVrYIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_d715208b9115fdb4673b85aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Alianza Preschool Energy Corridor",
      "poi_type": "Education",
      "poi_address": "1102 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-e9e8-728c-a039-8fc1bbe445d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-e9e8-728c-a039-8fc1bbe445d4",
        "storage_key": "property/5091000275959808/019f14fe-e9e8-728c-a039-8fc1bbe445d4.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "http://www.alianzaecoschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=937072933951976365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alianza-preschool-energy-corridor",
      "poi_latitude": "29.7686885",
      "poi_longitude": "-95.6239868",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-437-9776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315e-74bc-b594-d12c260cafc6",
        "storage_key": "property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh5k2PVTbQIYRrTPXXN4mAQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_230d60c0394cd5fec95e00d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Brimhurst KinderCare",
      "poi_type": "Education",
      "poi_address": "1407 Parkway Plaza Dr, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-e9fc-7452-bc42-c2809be0d36d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-e9fc-7452-bc42-c2809be0d36d",
        "storage_key": "property/5091000275959808/019f14fe-e9fc-7452-bc42-c2809be0d36d.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/houston/tx/301476?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3ODczLTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=10069797282617751256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brimhurst-kindercare",
      "poi_latitude": "29.7616371",
      "poi_longitude": "-95.63282780000002",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-531-1407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315e-74bc-b594-d12c260cafc6",
        "storage_key": "property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhc7DKwjcQIYR2PafxkYbv4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_d0dbb7539f314d43bc695e52",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Walnut Bend Elementary School",
      "poi_type": "Education",
      "poi_address": "10620 Briar Forest Dr, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-f1f1-74f5-afe4-30e3507e2e4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-f1f1-74f5-afe4-30e3507e2e4c",
        "storage_key": "property/5091000275959808/019f14fe-f1f1-74f5-afe4-30e3507e2e4c.webp",
        "width": 1280,
        "height": 814
      },
      "poi_business_url": "https://www.houstonisd.org/walnutbendes",
      "poi_directions_map_url": "https://maps.google.com/?cid=17870822258916306062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walnut-bend-elementary-school",
      "poi_latitude": "29.7477325",
      "poi_longitude": "-95.5636522",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-917-3540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315e-74bc-b594-d12c260cafc6",
        "storage_key": "property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK0nKfLPcQIYRjqzZKinqAfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_d139110fb2f2caea247b39a3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Paul Revere Middle School",
      "poi_type": "Education",
      "poi_address": "10502 Briar Forest Dr, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-f426-71db-90d6-9499c0954083.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-f426-71db-90d6-9499c0954083",
        "storage_key": "property/5091000275959808/019f14fe-f426-71db-90d6-9499c0954083.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15293944486870122678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paul-revere-middle-school",
      "poi_latitude": "29.7486547",
      "poi_longitude": "-95.5608907",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-917-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315e-74bc-b594-d12c260cafc6",
        "storage_key": "property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiTDco0zDQIYRtgBw4noBP9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_14b9fda6b91ee59235e6eb6a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "The Briarwood School",
      "poi_type": "Education",
      "poi_address": "12207 Whittington Dr, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-fa4e-7479-a5ec-f2c4888c03d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-fa4e-7479-a5ec-f2c4888c03d1",
        "storage_key": "property/5091000275959808/019f14fe-fa4e-7479-a5ec-f2c4888c03d1.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.briarwoodschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15803211460200525681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-briarwood-school",
      "poi_latitude": "29.7471306",
      "poi_longitude": "-95.595628",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-493-1070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315e-74bc-b594-d12c260cafc6",
        "storage_key": "property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaze0Y47cQIYRcW-iExhJUNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_d5dad6a15422e38e1874144a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Houston City College - West Loop Campus",
      "poi_type": "Education",
      "poi_address": "5601 W Loop S, Houston, TX 77081, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-f5b3-71b8-9082-27c74c48ae06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-f5b3-71b8-9082-27c74c48ae06",
        "storage_key": "property/5091000275959808/019f14fe-f5b3-71b8-9082-27c74c48ae06.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.hccs.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6584179847211332118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-city-college---west-loop-campus",
      "poi_latitude": "29.7214212",
      "poi_longitude": "-95.4581271",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 713-718-7868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315e-74bc-b594-d12c260cafc6",
        "storage_key": "property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ28ALNp7BQIYRFjJRwq-0X1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_1c21cd7bea21e435f3bbe2f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Memorial City Mall",
      "poi_type": "Entertainment",
      "poi_address": "303 Memorial City Way, Houston, TX 77024, USA",
      "poi_short_description": "Large complex with familiar retail shops, dining, movies, a carousel, play area & ice-skating rink.",
      "poi_long_description": "Large complex with familiar retail shops, dining, movies, a carousel, play area & ice-skating rink.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fc-e3ff-71dd-9973-7576be4011ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-e3ff-71dd-9973-7576be4011ad",
        "storage_key": "property/5091000275959808/019f14fc-e3ff-71dd-9973-7576be4011ad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.memorialcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11072518101315744963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-city-mall",
      "poi_latitude": "29.7807002",
      "poi_longitude": "-95.5379007",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-464-8640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314c-734b-819d-098b0822ddd1",
        "storage_key": "property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIXBsJZbEQIYRw_QBZox8qZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_c1e0b405c2e4f29743b7c67e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Cinemark Memorial City",
      "poi_type": "Entertainment",
      "poi_address": "310 Memorial City Mall, Houston, TX 77024, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-fb8b-7504-b87d-d87fed77d966.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-fb8b-7504-b87d-d87fed77d966",
        "storage_key": "property/5091000275959808/019f14fe-fb8b-7504-b87d-d87fed77d966.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-houston/cinemark-memorial-city?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxNTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13006184974408473747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-memorial-city",
      "poi_latitude": "29.7799092",
      "poi_longitude": "-95.5408135",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-467-9749",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-739a-7468-aeba-d3ec376bc44f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-739a-7468-aeba-d3ec376bc44f",
        "storage_key": "property/5091000275959808/019f14ff-739a-7468-aeba-d3ec376bc44f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJSwXHNpfEQIYRk9yjElNAf7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_0d3f1b290a9cd3141a536f3e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "CITYCENTRE",
      "poi_type": "Entertainment",
      "poi_address": "800 Town and Country Blvd, Houston, TX 77024, USA",
      "poi_short_description": "Contemporary shopping compound featuring brand-name stores, restaurants & live music in the plaza.",
      "poi_long_description": "Contemporary shopping compound featuring brand-name stores, restaurants & live music in the plaza.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fc-e27b-71ce-a6ae-c957125829ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-e27b-71ce-a6ae-c957125829ff",
        "storage_key": "property/5091000275959808/019f14fc-e27b-71ce-a6ae-c957125829ff.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.citycentrehouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16787131420789938490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "citycentre",
      "poi_latitude": "29.7810228",
      "poi_longitude": "-95.5592668",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 713-463-4692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314c-734b-819d-098b0822ddd1",
        "storage_key": "property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTQ_xOrPEQIYROpn7zRXf9-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_8ef9ede891e44febb2bfa939",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Star Cinema Grill CityCentre",
      "poi_type": "Entertainment",
      "poi_address": "CityCenter, 822 Town and Country Blvd Ste 200, Houston, TX 77024, USA",
      "poi_short_description": "Theatre featuring seat-side service, reclining chairs, heated seats and an expanded menu.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-ffcb-7481-9ec3-1389da022cc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-ffcb-7481-9ec3-1389da022cc6",
        "storage_key": "property/5091000275959808/019f14fe-ffcb-7481-9ec3-1389da022cc6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.starcinemagrill.net/movie-theater/citycentre",
      "poi_directions_map_url": "https://maps.google.com/?cid=5867569438081115187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "star-cinema-grill-citycentre",
      "poi_latitude": "29.7816296",
      "poi_longitude": "-95.5610211",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-277-7910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-739a-7468-aeba-d3ec376bc44f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-739a-7468-aeba-d3ec376bc44f",
        "storage_key": "property/5091000275959808/019f14ff-739a-7468-aeba-d3ec376bc44f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJHdroU0PFQIYRM2TD81DLbVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_9515754c79bd756e5be601a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Town & Country Village",
      "poi_type": "Entertainment",
      "poi_address": "12850 Memorial Dr, Houston, TX 77024, USA",
      "poi_short_description": "Upscale shopping plaza featuring clothing, furniture, electronics & craft stores, plus eateries.",
      "poi_long_description": "Upscale shopping plaza featuring clothing, furniture, electronics & craft stores, plus eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-0475-7112-84a1-8108274ee39a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-0475-7112-84a1-8108274ee39a",
        "storage_key": "property/5091000275959808/019f14ff-0475-7112-84a1-8108274ee39a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.townandcountryvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14313415948417426199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town--country-village",
      "poi_latitude": "29.7753305",
      "poi_longitude": "-95.5602272",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-464-7353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314c-734b-819d-098b0822ddd1",
        "storage_key": "property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn_RK26zEQIYRF-PUJ_h3o8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_851cbeb43a1910c641efeeaf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Memorial Park",
      "poi_type": "Entertainment",
      "poi_address": "6501 Memorial Dr, Houston, TX 77007, USA",
      "poi_short_description": "Expansive city park with lush natural features, popular running trail, golf course & lots of shade.",
      "poi_long_description": "Expansive city park with lush natural features, popular running trail, golf course & lots of shade.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-0435-774c-b5d5-41ccfffeb8ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-0435-774c-b5d5-41ccfffeb8ed",
        "storage_key": "property/5091000275959808/019f14ff-0435-774c-b5d5-41ccfffeb8ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.memorialparkconservancy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=822229581796948790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "29.7667498",
      "poi_longitude": "-95.4410469",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 50 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 713-863-8403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-31a8-71ac-86af-301d4cd2e4ec",
        "storage_key": "property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDyV1iizBQIYRNjvTwnIlaQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7022ded4ee428627e40fcb85",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Bear Creek Pioneers Park",
      "poi_type": "Entertainment",
      "poi_address": "3535 War Memorial St, Houston, TX 77084, USA",
      "poi_short_description": "Wooded park known for abundant wildlife such as deer & ducks, with many trails, fields & activities.",
      "poi_long_description": "Wooded park known for abundant wildlife such as deer & ducks, with many trails, fields & activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-0fb7-70bf-985a-910d1b55800e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-0fb7-70bf-985a-910d1b55800e",
        "storage_key": "property/5091000275959808/019f14fd-0fb7-70bf-985a-910d1b55800e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=15025692315525117298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-creek-pioneers-park",
      "poi_latitude": "29.8252332",
      "poi_longitude": "-95.6270195",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-31a8-71ac-86af-301d4cd2e4ec",
        "storage_key": "property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwGbtFzaQIYRcvUwK437hdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_cdb13ea3c68047b9ad5ea724",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Topgolf Houston - Katy",
      "poi_type": "Entertainment",
      "poi_address": "1030 Memorial Brook Blvd, Houston, TX 77084, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fc-e83b-74b7-b138-470c86779b95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-e83b-74b7-b138-470c86779b95",
        "storage_key": "property/5091000275959808/019f14fc-e83b-74b7-b138-470c86779b95.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/houston-west/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11763942538676567838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-houston---katy",
      "poi_latitude": "29.7867434",
      "poi_longitude": "-95.6500505",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-406-3176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315f-739b-aa8b-498df28ce044",
        "storage_key": "property/5091000275959808/019f14fd-315f-739b-aa8b-498df28ce044.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhW-E02bZQIYRHn_sL2nrQaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_f079654ed521e2c1d699da1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "The Galleria",
      "poi_type": "Entertainment",
      "poi_address": "5085 Westheimer Rd, Houston, TX 77056, USA",
      "poi_short_description": "Bright center with a glass roof offers ice skating & cafes, plus electronics & department stores.",
      "poi_long_description": "Bright center with a glass roof offers ice skating & cafes, plus electronics & department stores.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-0222-730f-9a61-9d90876e7e94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-0222-730f-9a61-9d90876e7e94",
        "storage_key": "property/5091000275959808/019f14ff-0222-730f-9a61-9d90876e7e94.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.simon.com/mall/the-galleria",
      "poi_directions_map_url": "https://maps.google.com/?cid=9080376292649229487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-galleria",
      "poi_latitude": "29.7391955",
      "poi_longitude": "-95.4634342",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 713-622-0663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314c-734b-819d-098b0822ddd1",
        "storage_key": "property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0b3z7m7BQIYRr1w81iD6A34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_eec4936e3ec4a67014fa6760",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "The River Oaks Theatre",
      "poi_type": "Entertainment",
      "poi_address": "2009 W Gray St, Houston, TX 77019, USA",
      "poi_short_description": "Retro theater with comfy seats, a bar and a snack kiosk, screening art-house films.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-0494-72c8-983a-f486c55c5dac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-0494-72c8-983a-f486c55c5dac",
        "storage_key": "property/5091000275959808/019f14ff-0494-72c8-983a-f486c55c5dac.webp",
        "width": 850,
        "height": 315
      },
      "poi_business_url": "https://www.theriveroakstheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=790177706486962063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-river-oaks-theatre",
      "poi_latitude": "29.7526485",
      "poi_longitude": "-95.4091314",
      "poi_miles_from_property": "13.8 mi",
      "poi_walking_minutes": "5 hours 12 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 713-496-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-739a-7468-aeba-d3ec376bc44f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-739a-7468-aeba-d3ec376bc44f",
        "storage_key": "property/5091000275959808/019f14ff-739a-7468-aeba-d3ec376bc44f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJha2IEbzAQIYRj5eWAHBG9wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_df3259074c4ba3cace11a252",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "First Choice Emergency Room",
      "poi_type": "Health and Wellness",
      "poi_address": "1717 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-05b4-70b2-b5d1-dda884e63c4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-05b4-70b2-b5d1-dda884e63c4e",
        "storage_key": "property/5091000275959808/019f14ff-05b4-70b2-b5d1-dda884e63c4e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4860011973458740812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-choice-emergency-room",
      "poi_latitude": "29.75210179999999",
      "poi_longitude": "-95.6246905",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-672-4010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6nySQ3cQIYRTEYn8iM7ckM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_7d61d52f514f90ea517e8c29",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Apex Urgent Care Energy Corridor",
      "poi_type": "Health and Wellness",
      "poi_address": "1398 Eldridge Pkwy #113, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-1034-714e-a247-4f22cb3e3ec4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-1034-714e-a247-4f22cb3e3ec4",
        "storage_key": "property/5091000275959808/019f14ff-1034-714e-a247-4f22cb3e3ec4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.apexurgentclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14639452188469508232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apex-urgent-care-energy-corridor",
      "poi_latitude": "29.7610258",
      "poi_longitude": "-95.6261245",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 346-576-8155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHWet0pDdQIYRiDgKyDPIKcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_b09a73c2a52fa79b7575c735",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Lifeline Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "13410 Briar Forest Dr Ste 190, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-0559-738c-b441-7e06b81588d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-0559-738c-b441-7e06b81588d5",
        "storage_key": "property/5091000275959808/019f14ff-0559-738c-b441-7e06b81588d5.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "http://www.lifelineurgentcare.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17994287110899831464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lifeline-urgent-care",
      "poi_latitude": "29.7561304",
      "poi_longitude": "-95.626095",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-771-1144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa3eJogzcQIYRqBKTH8qMuPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_d7adde8bdeae0a73ec4ca230",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "AFC Urgent Care Eldridge",
      "poi_type": "Health and Wellness",
      "poi_address": "6340 N Eldridge Pkwy Ste.O, Houston, TX 77041, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-1618-7195-a838-8d71f79e488e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-1618-7195-a838-8d71f79e488e",
        "storage_key": "property/5091000275959808/019f14ff-1618-7195-a838-8d71f79e488e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.afcurgentcare.com/eldridge/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-eldridge-gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=5059040201739461010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-eldridge",
      "poi_latitude": "29.8641401",
      "poi_longitude": "-95.6063888",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 346-389-7919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHTo7BFnRQIYRkuEZcUJSNUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_9a6d9c8b023da4a308434fb8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1506 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-123f-70d8-b988-f349df1ed224.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-123f-70d8-b988-f349df1ed224",
        "storage_key": "property/5091000275959808/019f14ff-123f-70d8-b988-f349df1ed224.webp",
        "width": 606,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1506+eldridge+pkwy-houston-tx-77077/id=5313",
      "poi_directions_map_url": "https://maps.google.com/?cid=5086806996704169853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "29.7565006",
      "poi_longitude": "-95.6260314",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-558-4565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-73a6-7639-94d1-981654b4945a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-73a6-7639-94d1-981654b4945a",
        "storage_key": "property/5091000275959808/019f14ff-73a6-7639-94d1-981654b4945a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4TODXgvcQIYRfQ-GLwP4l0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_8960e5d40d87ee7007d5bd3a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1520 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-0f26-740b-a7b0-9ba5c2167cfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-0f26-740b-a7b0-9ba5c2167cfa",
        "storage_key": "property/5091000275959808/019f14ff-0f26-740b-a7b0-9ba5c2167cfa.webp",
        "width": 796,
        "height": 503
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/034/00349?cid=loc_03400349P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1009349086947144735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "29.7574744",
      "poi_longitude": "-95.6273772",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-496-7719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-73a6-7639-94d1-981654b4945a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-73a6-7639-94d1-981654b4945a",
        "storage_key": "property/5091000275959808/019f14ff-73a6-7639-94d1-981654b4945a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWl8sAzcQIYRH3TZlaXtAQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_dc1f55bfdb9d3e015acdd8b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 Eldridge Pkwy, Houston, TX 77082, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fe-d661-7569-accf-584baf37553f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-d661-7569-accf-584baf37553f",
        "storage_key": "property/5091000275959808/019f14fe-d661-7569-accf-584baf37553f.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/houston-tx-pharmacies/2700-eldridge-pkwy-houston-tx-77082/storeid=17476?WT.mc_id=LS_GOOGLE_RX_17476",
      "poi_directions_map_url": "https://maps.google.com/?cid=2821342438639300871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.7327035",
      "poi_longitude": "-95.6272309",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-810-5252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-73a6-7639-94d1-981654b4945a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-73a6-7639-94d1-981654b4945a",
        "storage_key": "property/5091000275959808/019f14ff-73a6-7639-94d1-981654b4945a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0nYzTjcQIYRB3HU9P9rJyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d9e69fda42d7f2c8f512e612",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1555 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "Clean gym featuring treadmills, weights, group fitness classes and an indoor pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fc-fb6e-74a2-aca9-6313f139af36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-fb6e-74a2-aca9-6313f139af36",
        "storage_key": "property/5091000275959808/019f14fc-fb6e-74a2-aca9-6313f139af36.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=328&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9378932379517840822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "29.7552509",
      "poi_longitude": "-95.6229603",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-558-3801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3W7QXPcQIYRtu2RtU6pKII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_d12845b218cb094a5de1aad3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "HOTWORX - Houston, TX - Energy Corridor",
      "poi_type": "Health and Wellness",
      "poi_address": "1140 Eldridge Pkwy Ste 150, Houston, TX 77077, USA",
      "poi_short_description": "Gym with infrared saunas and 24/7 access providing HIIT and isometric workouts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-1792-7309-a7cc-899ea9520736.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-1792-7309-a7cc-899ea9520736",
        "storage_key": "property/5091000275959808/019f14ff-1792-7309-a7cc-899ea9520736.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hotworx.net/studio/houston-energycorridor?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=15357018356697824165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---houston-tx---energy-corridor",
      "poi_latitude": "29.7678491",
      "poi_longitude": "-95.6246438",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-529-1663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315e-74bc-b594-d12c260cafc6",
        "storage_key": "property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVZWgM2DbQIYRpXsgmNQWH9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_6c911387574d3f8b61c87be1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Massage Heights Champions Village",
      "poi_type": "Health and Wellness",
      "poi_address": "5403 FM 1960 W Ste A, Houston, TX 77069, USA",
      "poi_short_description": "Chain spa offering massages and skin therapy in a relaxing setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-142f-760d-bbae-ee4372cd20e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-142f-760d-bbae-ee4372cd20e2",
        "storage_key": "property/5091000275959808/019f14ff-142f-760d-bbae-ee4372cd20e2.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.heightswellnessretreat.com/champions-village",
      "poi_directions_map_url": "https://maps.google.com/?cid=14488357614728162548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "massage-heights-champions-village",
      "poi_latitude": "29.9797579",
      "poi_longitude": "-95.511829",
      "poi_miles_from_property": "21.7 mi",
      "poi_walking_minutes": "8 hours 1 min",
      "poi_biking_minutes": "2 hours 4 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 281-324-8842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsyFIQknMQIYR9Kyy7Hz8EMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage_spa"
    },
    {
      "id": "ec_5ed362b7bd3ce7089298a32c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Ray Miller Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1800 Eldridge Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "City park that has a gazebo & fountain, plus a butterfly garden & walking trails, over 15 acres.",
      "poi_long_description": "City park that has a gazebo & fountain, plus a butterfly garden & walking trails, over 15 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-1eaf-773c-aed3-0607fe507c89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-1eaf-773c-aed3-0607fe507c89",
        "storage_key": "property/5091000275959808/019f14ff-1eaf-773c-aed3-0607fe507c89.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://cp4.harriscountytx.gov/Explore/Parks/park/ray-miller-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5272265620733080176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ray-miller-park",
      "poi_latitude": "29.7506508",
      "poi_longitude": "-95.6270974",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-31a8-71ac-86af-301d4cd2e4ec",
        "storage_key": "property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyxFCfQ3cQIYRcLJM_aXZKkk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_12f064b0cbd22dd91d2bc523",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Energy Corridor Trailhead Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7816236785786176446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "energy-corridor-trailhead-park",
      "poi_latitude": "29.77246229999999",
      "poi_longitude": "-95.6201432",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-31a8-71ac-86af-301d4cd2e4ec",
        "storage_key": "property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzO7YgXbQIYRvkMgyfHZeGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_faaaba4208afe67d94c4cc46",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Beeler Memorial Pocket Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1150 Enclave Pkwy, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-21ca-725b-96c9-cd192493ebea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-21ca-725b-96c9-cd192493ebea",
        "storage_key": "property/5091000275959808/019f14ff-21ca-725b-96c9-cd192493ebea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=13776044284360054384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beeler-memorial-pocket-park",
      "poi_latitude": "29.7662137",
      "poi_longitude": "-95.6221675",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-31a8-71ac-86af-301d4cd2e4ec",
        "storage_key": "property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuwTCn4vbQIYRcNZUu0lXLr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_94922b1323ccdbadad9cc366",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Terry Hershey Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15200 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Extensive network of hiking & biking trails along a stretch of Buffalo Bayou encompassing 500 acres.",
      "poi_long_description": "Extensive network of hiking & biking trails along a stretch of Buffalo Bayou encompassing 500 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-26dc-703c-8678-1f24fd4c14b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-26dc-703c-8678-1f24fd4c14b2",
        "storage_key": "property/5091000275959808/019f14ff-26dc-703c-8678-1f24fd4c14b2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=839903759849692222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terry-hershey-park",
      "poi_latitude": "29.7817875",
      "poi_longitude": "-95.623719",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-31a8-71ac-86af-301d4cd2e4ec",
        "storage_key": "property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnSEHspTbQIYRPhxbAwXwpws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e3e8e56dae8c803fe9beb468",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Molly Pryor Memorial Orchard",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15200 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Compact county park with a trellis, gazebo, ornamental garden & walking trail.",
      "poi_long_description": "Compact county park with a trellis, gazebo, ornamental garden & walking trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-21bd-7355-b2eb-b95d82cf07b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-21bd-7355-b2eb-b95d82cf07b4",
        "storage_key": "property/5091000275959808/019f14ff-21bd-7355-b2eb-b95d82cf07b4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=481790785141622011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "molly-pryor-memorial-orchard",
      "poi_latitude": "29.7787225",
      "poi_longitude": "-95.6230158",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-31a8-71ac-86af-301d4cd2e4ec",
        "storage_key": "property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnSEHspTbQIYR-0RsnCqqrwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d27ed4174beb0735873c0e4d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Nottingham Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14205 Kimberley Ln, Houston, TX 77079, USA",
      "poi_short_description": "Popular 22-acre area features a splash park, playground, 12-hole disc golf course & tennis courts.",
      "poi_long_description": "Popular 22-acre area features a splash park, playground, 12-hole disc golf course & tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-20ac-7072-9591-86b8bd444d57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-20ac-7072-9591-86b8bd444d57",
        "storage_key": "property/5091000275959808/019f14ff-20ac-7072-9591-86b8bd444d57.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=9767241299191602211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nottingham-park",
      "poi_latitude": "29.7759158",
      "poi_longitude": "-95.5971155",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-31a8-71ac-86af-301d4cd2e4ec",
        "storage_key": "property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ20q2lXDbQIYRIxzXaTY2jIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d153f7271155f1db97660a9e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Archbishop Joseph A. Fiorenza Park East",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4025 Eldridge Pkwy, Houston, TX 77082, USA",
      "poi_short_description": "Landscaped park on 12.5 acres with gazebos, trails, picnic areas, and a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-2f78-772c-a7b2-27130e25ab0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-2f78-772c-a7b2-27130e25ab0f",
        "storage_key": "property/5091000275959808/019f14ff-2f78-772c-a7b2-27130e25ab0f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=15471444144309387309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "archbishop-joseph-a-fiorenza-park-east",
      "poi_latitude": "29.713788",
      "poi_longitude": "-95.6220054",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-31a8-71ac-86af-301d4cd2e4ec",
        "storage_key": "property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJsZc0ANyWXhQRLcDbX3qctdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_91bc326fa9ab64fb823788fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "George Bush Park Bike Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16756 Westheimer Pkwy, Houston, TX 77082, USA",
      "poi_short_description": "Family-friendly park with scenic views and a long trail for walking, biking or running.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-3636-75aa-9910-722e8ff76791.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-3636-75aa-9910-722e8ff76791",
        "storage_key": "property/5091000275959808/019f14ff-3636-75aa-9910-722e8ff76791.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=469630594180836084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-park-bike-trail",
      "poi_latitude": "29.7236788",
      "poi_longitude": "-95.6875102",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-31a8-71ac-86af-301d4cd2e4ec",
        "storage_key": "property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9-5hIuDeQIYR9OrNhYl2hAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_62017200eb985f284bb8db7c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Millie Bush Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16101 Westheimer Rd, Houston, TX 77082, USA",
      "poi_short_description": "Separate areas for small & large dogs, plus a walking trail, ponds & a dog shower.",
      "poi_long_description": "Separate areas for small & large dogs, plus a walking trail, ponds & a dog shower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-2b82-738c-ab10-1df51af3f999.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-2b82-738c-ab10-1df51af3f999",
        "storage_key": "property/5091000275959808/019f14ff-2b82-738c-ab10-1df51af3f999.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://cp4.harriscountytx.gov/dogparks",
      "poi_directions_map_url": "https://maps.google.com/?cid=14209373870009034643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "millie-bush-dog-park",
      "poi_latitude": "29.72655929999999",
      "poi_longitude": "-95.6686648",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-31a8-71ac-86af-301d4cd2e4ec",
        "storage_key": "property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8fQ455jeQIYRkyebEkDWMcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_b3a9ede04dd02404816d62f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Bear Creek Pioneers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3535 War Memorial St, Houston, TX 77084, USA",
      "poi_short_description": "Wooded park known for abundant wildlife such as deer & ducks, with many trails, fields & activities.",
      "poi_long_description": "Wooded park known for abundant wildlife such as deer & ducks, with many trails, fields & activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-0fb7-70bf-985a-910d1b55800e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-0fb7-70bf-985a-910d1b55800e",
        "storage_key": "property/5091000275959808/019f14fd-0fb7-70bf-985a-910d1b55800e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=15025692315525117298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-creek-pioneers-park",
      "poi_latitude": "29.8252332",
      "poi_longitude": "-95.6270195",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-31a8-71ac-86af-301d4cd2e4ec",
        "storage_key": "property/5091000275959808/019f14fd-31a8-71ac-86af-301d4cd2e4ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwGbtFzaQIYRcvUwK437hdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6afb6c34682c82d9ca43126c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Addicks Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "14230 Old Katy Rd, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-3ac1-7517-ada8-303845cf4bcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-3ac1-7517-ada8-303845cf4bcc",
        "storage_key": "property/5091000275959808/019f14ff-3ac1-7517-ada8-303845cf4bcc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6059542481948761620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "addicks-park--ride",
      "poi_latitude": "29.7872884",
      "poi_longitude": "-95.6383329",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-7398-7719-a78c-7373671f1ef1",
        "storage_key": "property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xDFp93bQIYRFN7xUcjRF1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_443fab4e5b79c2761acfd749",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Northwest Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7373 Old Katy Rd, Houston, TX 77024, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-41d0-746f-a468-84daa0c82119.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-41d0-746f-a468-84daa0c82119",
        "storage_key": "property/5091000275959808/019f14ff-41d0-746f-a468-84daa0c82119.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridemetro.org/pages/TC-Northwest.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4887889931563584101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-transit-center",
      "poi_latitude": "29.7833768",
      "poi_longitude": "-95.4545941",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq3DSrsfGQIYRZUoO4P5F1UM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_d15b4ae77b04a64de925c8a7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Mission Bend Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "13855 Alief Clodine Rd, Houston, TX 77083, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-3d7d-72e0-aa36-a1608bbffaf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-3d7d-72e0-aa36-a1608bbffaf6",
        "storage_key": "property/5091000275959808/019f14ff-3d7d-72e0-aa36-a1608bbffaf6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5645848562512495656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-bend-transit-center",
      "poi_latitude": "29.7112995",
      "poi_longitude": "-95.6294303",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-7398-7719-a78c-7373671f1ef1",
        "storage_key": "property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJt1S35MvdQIYRKAQ1yFoVWk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_b009ebc3e45c725916818546",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Westpark/Lower Uptown Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5105 Westpark Dr, Houston, TX 77056, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-3951-76bd-a5c6-0e45023f6e48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-3951-76bd-a5c6-0e45023f6e48",
        "storage_key": "property/5091000275959808/019f14ff-3951-76bd-a5c6-0e45023f6e48.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2350213791813892094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westparklower-uptown-transit-center",
      "poi_latitude": "29.72532499999999",
      "poi_longitude": "-95.4650342",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-7398-7719-a78c-7373671f1ef1",
        "storage_key": "property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJFUi1hV3BQIYR_ndK3_2inSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_6c107f3ada67d635fa4dc717",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Westchase Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "11050 Harwin Dr., Houston, TX 77072, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-4875-72dc-8331-143dda58e303.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-4875-72dc-8331-143dda58e303",
        "storage_key": "property/5091000275959808/019f14ff-4875-72dc-8331-143dda58e303.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5396743279492684688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westchase-park-and-ride",
      "poi_latitude": "29.717204",
      "poi_longitude": "-95.5628297",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-7398-7719-a78c-7373671f1ef1",
        "storage_key": "property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJIX9fwSrdQIYRkFsjZmsV5Uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_8325163a3cedd4b61d2814f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Gessner Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "9925 Westpark Dr, Houston, TX 77063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-4939-7761-9be4-18dfd9c4df6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-4939-7761-9be4-18dfd9c4df6f",
        "storage_key": "property/5091000275959808/019f14ff-4939-7761-9be4-18dfd9c4df6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8759854959400057547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gessner-park-and-ride",
      "poi_latitude": "29.72044959999999",
      "poi_longitude": "-95.5374292",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-7398-7719-a78c-7373671f1ef1",
        "storage_key": "property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJYdfhzB_DQIYRy_r7gqxBkXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_e895912ce6da48bb7f0a578e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Northwest Station Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "18502 Northwest Fwy, Houston, TX 77065, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-587c-763b-bed3-245e484847ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-587c-763b-bed3-245e484847ca",
        "storage_key": "property/5091000275959808/019f14ff-587c-763b-bed3-245e484847ca.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15540130698840525853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-station-park--ride",
      "poi_latitude": "29.90224199999999",
      "poi_longitude": "-95.5940473",
      "poi_miles_from_property": "14.9 mi",
      "poi_walking_minutes": "5 hours 31 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-7398-7719-a78c-7373671f1ef1",
        "storage_key": "property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yxMh1LQQIYRHUyIE4miqdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_1ec0ee246ffbc0b32698d95a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Westwood Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "9990 Southwest Fwy, Houston, TX 77036, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-42ae-75fc-8c7a-fb22f184e5ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-42ae-75fc-8c7a-fb22f184e5ce",
        "storage_key": "property/5091000275959808/019f14ff-42ae-75fc-8c7a-fb22f184e5ce.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13297390603034044934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westwood-park-and-ride",
      "poi_latitude": "29.6719084",
      "poi_longitude": "-95.548911",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-7398-7719-a78c-7373671f1ef1",
        "storage_key": "property/5091000275959808/019f14ff-7398-7719-a78c-7373671f1ef1.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJJXAMnR3oQIYRBip2BU3Sibg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_e0d8babefb716b79b2f4f3b8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Phillips 66",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2331 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-0a41-7128-8ced-daf6d3c37f69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-0a41-7128-8ced-daf6d3c37f69",
        "storage_key": "property/5091000275959808/019f14fd-0a41-7128-8ced-daf6d3c37f69.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.phillips66.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860930961646065326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phillips-66",
      "poi_latitude": "29.7405404",
      "poi_longitude": "-95.5609181",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZb3nsDrDQIYRrpbov6xYHdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_6fc6b8f929d11164d97bdb5e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "SLB",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3600 Briarpark Dr, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-5a7c-7588-bfa6-35a80c272930.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-5a7c-7588-bfa6-35a80c272930",
        "storage_key": "property/5091000275959808/019f14ff-5a7c-7588-bfa6-35a80c272930.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.slb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13818242362392249710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slb",
      "poi_latitude": "29.7252666",
      "poi_longitude": "-95.55029",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-285-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4ZrPibDQIYRbgWlZjdCxL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_edcac190bf53afcec9da3a87",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Bechtel Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2105 CityWest Blvd Garage 3, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-6b8f-77e4-9115-badc05fa6a84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-6b8f-77e4-9115-badc05fa6a84",
        "storage_key": "property/5091000275959808/019f14ff-6b8f-77e4-9115-badc05fa6a84.webp",
        "width": 1280,
        "height": 512
      },
      "poi_business_url": "https://www.bechtel.com/contact/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6414285375339213611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bechtel-corporation",
      "poi_latitude": "29.743473",
      "poi_longitude": "-95.5589527",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-235-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9xNoFADDQIYRK7MThZAeBFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_15706ba83e657bac61462db7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Equinor US",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2107 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-56df-779a-b4ac-b7f2c690ff71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-56df-779a-b4ac-b7f2c690ff71",
        "storage_key": "property/5091000275959808/019f14ff-56df-779a-b4ac-b7f2c690ff71.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.equinor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11463863649548003173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "equinor-us",
      "poi_latitude": "29.7445358",
      "poi_longitude": "-95.5605733",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-918-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk5eyiErDQIYRZWfSSEDTF58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_d9fbdfe34385df2c1fc8c353",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Honeywell",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-239c-732b-933b-3904451bc01f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-239c-732b-933b-3904451bc01f",
        "storage_key": "property/5091000275959808/019f14fd-239c-732b-933b-3904451bc01f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.honeywell.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4963438541816280246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honeywell",
      "poi_latitude": "29.7426637",
      "poi_longitude": "-95.5606149",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 832-252-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyWdeRUzDQIYRtjRxbQ6t4UQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_53958c8c2a0705a2e7081bc4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "BMC Software",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2103 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-567f-7059-8509-bbd6a906b2cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-567f-7059-8509-bbd6a906b2cf",
        "storage_key": "property/5091000275959808/019f14ff-567f-7059-8509-bbd6a906b2cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bmc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5294375881449965582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bmc-software",
      "poi_latitude": "29.7425039",
      "poi_longitude": "-95.5594056",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-793-4262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7FQr0rDQIYRDog4OdBmeUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_57389c1aaea9bfbc488ff322",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "ABB Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3700 W Sam Houston Pkwy S, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-5f0d-73c8-ad58-e49c3559451f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-5f0d-73c8-ad58-e49c3559451f",
        "storage_key": "property/5091000275959808/019f14ff-5f0d-73c8-ad58-e49c3559451f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.abb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4905928342324721908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abb-inc",
      "poi_latitude": "29.7241246",
      "poi_longitude": "-95.5587989",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 713-587-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314e-74bf-b69d-d44e2ff85c58",
        "storage_key": "property/5091000275959808/019f14fd-314e-74bf-b69d-d44e2ff85c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo9SwhSvDQIYR9DjJqdVbFUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_f4adbaf1c8e76440240e2864",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Mattress Firm Bedquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3250 Briarpark Dr #400, Houston, TX 77042, USA",
      "poi_short_description": "Mattress store offering a variety of furniture.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-5acd-70b8-a987-dbab5079a049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-5acd-70b8-a987-dbab5079a049",
        "storage_key": "property/5091000275959808/019f14ff-5acd-70b8-a987-dbab5079a049.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mattressfirm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13301169338514303444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mattress-firm-bedquarters",
      "poi_latitude": "29.7312906",
      "poi_longitude": "-95.5503308",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-923-1090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-314c-734b-819d-098b0822ddd1",
        "storage_key": "property/5091000275959808/019f14fd-314c-734b-819d-098b0822ddd1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKYMOdoPqQIYR1Gl2bwo_l7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "ec_9cc6eea4e59c50807e63f99d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "American InterContinental University Houston Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9999 Richmond Ave, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-5b24-76b9-a30b-f92cdd98d0ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-5b24-76b9-a30b-f92cdd98d0ea",
        "storage_key": "property/5091000275959808/019f14ff-5b24-76b9-a30b-f92cdd98d0ea.webp",
        "width": 1280,
        "height": 954
      },
      "poi_business_url": "https://www.aiuniv.edu/campus-locations/houston",
      "poi_directions_map_url": "https://maps.google.com/?cid=12106239600354429584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-intercontinental-university-houston-campus",
      "poi_latitude": "29.7282111",
      "poi_longitude": "-95.5480926",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 832-201-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-315e-74bc-b594-d12c260cafc6",
        "storage_key": "property/5091000275959808/019f14fd-315e-74bc-b594-d12c260cafc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWxDdViTDQIYRkIrkYMYAAqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_5aa425b14de87f641a6ae183",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "poi_name": "Memorial Hermann Southwest Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7600 Beechnut St, Houston, TX 77074, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14ff-5b36-754c-980a-d66df389f373.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-5b36-754c-980a-d66df389f373",
        "storage_key": "property/5091000275959808/019f14ff-5b36-754c-980a-d66df389f373.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://memorialhermann.org/locations/southwest?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=4615674855845486349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-southwest-hospital",
      "poi_latitude": "29.692891",
      "poi_longitude": "-95.5212694",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 713-456-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14fd-320a-7653-8587-22c2b1d27ba3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-320a-7653-8587-22c2b1d27ba3",
        "storage_key": "property/5091000275959808/019f14fd-320a-7653-8587-22c2b1d27ba3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aSzG4zCQIYRDV9fldMrDkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    }
  ],
  "office_hours": [
    {
      "id": "custom_7f420d02-124c-46d0-aa79-2270ece19754",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d1145777-60e6-40a4-970c-821315dd1b2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2361f290-5ff2-4138-b2da-d1e3e6464629",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_328ddb3b-6c05-436f-89a5-2ef6a1fdba25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_af1ca0de-d4ee-430c-9e16-0c5c631f2745",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_f44dce3c-36c8-4f7d-bcfb-4c3915ed23eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_9192025b-edc6-4df3-94bf-7869c0a38992",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "rating": "5.0",
      "name": "Towaki",
      "text": "I had a wonderful experience. Karen is the best property manager I have ever met. She goes above and beyond to help you understand and get where you need to be to enjoy your new home. I love my new place. Karen and Ryan are a great team. I can always get help when I need it (not to computer savvy). I want to say a Big Thanks again to Karen, Ryan and the rest of the staff at Phillip’s Pass.",
      "date": "2026-06-05",
      "title": ""
    },
    {
      "id": "custom_bb33a62a-af95-4ee9-b9f8-339bac2d7c71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "rating": "5.0",
      "name": "nortlan moreira",
      "text": "I love this apartment complex building. It is very nice and fancy. Ms Karen is very kind and helpful. She has helped me a lot with my concerns. I strongly recommend this area if you are thinking to move here.",
      "date": "2026-06-04",
      "title": ""
    },
    {
      "id": "custom_d22f92fa-d41c-4586-8bf1-fce4e07daeb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "rating": "5.0",
      "name": "Stayingencouraged StrengthensME",
      "text": "Karen and Kelli have been absolutely wonderful during the application process. I came in with doubts about a personal situation regarding leasing and Kelli kept a positive outlook and made me feel comfortable applying.  Once I did things went so smooth with Karen the manager.  She explained some things that were actually AWESOME to me and congratulated me on being APPROVED.  These apartments are absolutely beautiful.  The setup is gorgeous as well. Parking is ample.  I'm very glad to have stopped in to Phillips Pass..a place I now call HOME.  Come in and lease... you won't be disappointed!",
      "date": "2026-02-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_f5f5e4c48537f50fe3f361d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f14c3-a359-75e9-8c33-62bb8333b3e9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-a359-75e9-8c33-62bb8333b3e9",
        "storage_key": "property/5091000275959808/019f14c3-a359-75e9-8c33-62bb8333b3e9.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Phillips Pass - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/MOgcGT6Ug1Y"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-d8b6-764c-b9f8-5ab172ad1eab",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "phillips-pass",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808"
    },
    {
      "lead_collector_id": "0198aa45-d918-731f-ad47-09fc3e842a7f",
      "lead_source": "FACEBOOK_ADS",
      "name": "phillips-pass",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808"
    },
    {
      "lead_collector_id": "0198aa45-d984-743a-9ac2-f75a6bbb6256",
      "lead_source": "LANDING_PAGE",
      "name": "phillips-pass",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-with-pool-in-houston-tx-phillips-pass-562",
      "search_query": "apartments with pool in Houston TX",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Houston, TX",
      "h2_subtitle": "Dive into comfort at Phillips Pass, home to one of the best pools among apartments with pool in Houston, TX. Experience fun and relaxation every day.",
      "page_copy": "If you're searching for apartments with pool in Houston, TX, look no further than Phillips Pass. Our vibrant community offers not only spacious one and two-bedroom floor plans but also an inviting pool ideal for relaxation and socializing. Whether you're unwinding after a long day or hosting a weekend gathering, our pool area provides the perfect setting.\n\nPhillips Pass goes beyond providing a prime location near the bustling Briar Village. Residents enjoy access to top-tier amenities including a modern fitness center, stainless steel appliances, and a dedicated on-site property manager. With the convenience of online services and LUXER Package Lockers, you'll find everything you need right at home. Discover why Phillips Pass stands out among apartments with a pool in Houston, TX, by scheduling a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Houston, TX | Phillips Pass",
      "seo_description": "Discover Phillips Pass, top apartments with pool in Houston, TX. Enjoy luxury amenities in a prime location. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-in-briar-village-phillips-pass-37",
      "search_query": "fitness center apartments in Briar Village",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Briar Village",
      "h2_subtitle": "Enjoy fitness center apartments in Briar Village at Phillips Pass. Achieve your wellness goals right at home!",
      "page_copy": "Welcome to Phillips Pass, where you will find fitness center apartments in Briar Village perfectly suited to meet your wellness lifestyle. Our fully-equipped fitness center ensures residents can maintain their health regimes without the need for a separate gym membership. With a range of top-of-the-line equipment, staying fit has never been more convenient.\n\nPhillips Pass offers more than just exceptional fitness amenities. Our community features spacious one and two-bedroom floor plans, a refreshing pool, and a resident clubhouse perfect for social gatherings. Conveniently located in the heart of Briar Village, residents enjoy easy access to the vibrant Houston scene. Choose Phillips Pass today and enjoy the convenience of fitness center apartments in Briar Village that support both your health and community spirit.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Briar Village | Phillips Pass",
      "seo_description": "Discover Phillips Pass for fitness center apartments in Briar Village. Achieve your health goals with our excellent facilities. Schedule a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-clubhouse-harris-county-phillips-pass-784",
      "search_query": "luxury apartments with clubhouse Harris County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Clubhouse in Harris County",
      "h2_subtitle": "Explore luxury apartments with clubhouse in Harris County at Phillips Pass. Experience premier living today.",
      "page_copy": "Discover the elegance of luxury apartments with clubhouse facilities in Harris County, right here at Phillips Pass. Our community offers upscale living with exclusive amenities that include a stylish resident clubhouse, perfect for hosting events or enjoying quiet relaxation with friends and neighbors.\n\nAt Phillips Pass, residents benefit from more than just luxurious spaces; they also enjoy a comprehensive lifestyle package. Our community in Houston provides spacious one and two-bedroom apartment homes, a sparkling pool, and a state-of-the-art fitness center. Nestled in the charming neighborhood of Briar Village, Phillips Pass represents the pinnacle of convenience and style among luxury apartments with clubhouse offerings in Harris County. Schedule a tour today and begin the lifestyle you deserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Clubhouse in Harris County",
      "seo_description": "Experience Phillips Pass, offering luxury apartments with clubhouse in Harris County. Enjoy premium amenities in a vibrant community. Book a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-near-77077-phillips-pass-758",
      "search_query": "in-unit laundry apartments near 77077",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments near 77077",
      "h2_subtitle": "Find in-unit laundry apartments near 77077 at Phillips Pass. Experience ultimate convenience and comfort in your new home.",
      "page_copy": "Searching for in-unit laundry apartments near 77077? Phillips Pass is the place for you! Our spacious one and two-bedroom floor plans come equipped with modern in-unit washers and dryers, offering you the ultimate convenience of not needing to share laundry facilities or make trips outside the home. \n\nBeyond this great perk, Phillips Pass provides a plethora of amenities including a refreshing pool, a state-of-the-art fitness center, and a welcoming resident clubhouse. Situated in the vibrant Briar Village neighborhood, our community offers easy access to nearby local attractions, making it a prime choice for those looking for both convenience and modern living. Discover the advantages of choosing in-unit laundry apartments near 77077 at Phillips Pass today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments near 77077 | Phillips Pass",
      "seo_description": "Discover in-unit laundry apartments near 77077 at Phillips Pass. Enjoy modern conveniences and prime location. Schedule your tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-in-houston-phillips-pass-152",
      "search_query": "air conditioned apartments in Houston",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Houston",
      "h2_subtitle": "Discover air conditioned apartments in Houston at Phillips Pass. Enjoy comfort all year round in your new home.",
      "page_copy": "If you're in search of air conditioned apartments in Houston, look no further than Phillips Pass. Our community offers a cool retreat from the bustling city life, ensuring you stay comfortable no matter the season. Each of our one and two-bedroom apartments is fully equipped with efficient air conditioning systems, providing a serene escape from the Texas heat.\n\nPhillips Pass enhances your living experience with an array of amenities, including a modern fitness center and a community pool perfect for cooling down. Situated in the charming Briar Village neighborhood, our air conditioned apartments provide easy access to Houston's vibrant offerings while ensuring a tranquil home environment. Come visit us and find your perfect haven at Phillips Pass today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Houston | Phillips Pass",
      "seo_description": "Explore air conditioned apartments in Houston at Phillips Pass. Stay cool and comfortable with our excellent amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-houston-tx-phillips-pass-773",
      "search_query": "1 bedroom apartments houston tx",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Houston, TX",
      "h2_subtitle": "Explore 1 bedroom apartments in Houston, TX at Phillips Pass. Experience modern living in a vibrant community.",
      "page_copy": "Phillips Pass is proud to offer 1 bedroom apartments in Houston, TX that perfectly blend style and convenience. Our thoughtfully designed floor plans provide ample space and comfort, making it an ideal choice for singles or couples looking for a place that meets their needs. With sleek finishes and modern appliances, including in-unit washers and dryers, you’ll find both functionality and elegance.\n\nLocated in the lively Briar Village neighborhood, Phillips Pass offers more than just a home. Residents have access to top-notch amenities such as a fully equipped fitness center, a soothing community pool, and a welcoming resident clubhouse. Experience the charm of our community with easy access to Houston's cultural, dining, and entertainment options. Discover why our 1 bedroom apartments in Houston, TX are the best choice for effortless city living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Houston, TX | Phillips Pass",
      "seo_description": "Discover modern 1 bedroom apartments in Houston, TX at Phillips Pass. Enjoy top amenities and vibrant community life. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-near-briar-village-phillips-pass-44",
      "search_query": "2 bedroom apartments near briar village",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near Briar Village",
      "h2_subtitle": "Find 2 bedroom apartments near Briar Village at Phillips Pass. Experience spacious living in a prime Houston location.",
      "page_copy": "Looking for 2 bedroom apartments near Briar Village? At Phillips Pass, we offer spacious and modern two-bedroom floor plans perfect for families, roommates, or anyone needing extra space. Our apartments are designed with contemporary aesthetics and equipped with conveniences like in-unit washers and dryers, making everyday living seamless and delightful.\n\nNestled in the heart of Briar Village, our community provides a unique combination of tranquility and accessibility. Residents enjoy engaging amenities such as a well-equipped fitness center, a refreshing pool, and a friendly clubhouse designed for social gatherings. Plus, Phillips Pass offers a convenient location just moments away from Houston's finest shopping, dining, and entertainment. Discover the advantages of living in our 2 bedroom apartments near Briar Village today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near Briar Village | Phillips Pass",
      "seo_description": "Explore spacious 2 bedroom apartments near Briar Village at Phillips Pass in Houston. Enjoy modern amenities and a prime location. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-near-american-college-of-acupuncture-houston-635",
      "search_query": "apartments near American College of Acupuncture & Oriental Medicine Houston",
      "category": "School",
      "h1_title": "Apartments Near American College of Acupuncture",
      "h2_subtitle": "Discover apartments near American College of Acupuncture & Oriental Medicine in Houston. Enjoy convenient access to your studies.",
      "page_copy": "For students and professionals seeking apartments near American College of Acupuncture & Oriental Medicine in Houston, Phillips Pass is an ideal choice. Our community offers modern living spaces that provide a comfortable and convenient setting, perfect for academic and career pursuits. Enjoy spacious one and two-bedroom apartments outfitted with contemporary amenities, including in-unit washers and dryers.\n\nLocated just a short drive from the college, Phillips Pass ensures an easy commute while offering a peaceful retreat. The community boasts excellent facilities like a fitness center and a swimming pool, ideal for unwinding after a busy day. Situated in the lively Briar Village area, residents have access to a variety of dining and shopping options, enhancing their living experience. Choose Phillips Pass for a balanced and enriching lifestyle near the American College of Acupuncture & Oriental Medicine.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near American College of Acupuncture | Phillips Pass",
      "seo_description": "Find convenient apartments near American College of Acupuncture & Oriental Medicine at Phillips Pass in Houston. Perfect for students and professionals. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-close-to-center-for-advanced-legal-studies-tx-600",
      "search_query": "apartments close to Center for Advanced Legal Studies TX",
      "category": "School",
      "h1_title": "Apartments Close to Center for Advanced Legal Studies",
      "h2_subtitle": "Find the ideal apartments close to Center for Advanced Legal Studies in Houston, TX. Experience convenience and comfort at Phillips Pass.",
      "page_copy": "If you are searching for apartments close to Center for Advanced Legal Studies in Houston, TX, consider making Phillips Pass your new home. Our community features elegant one and two-bedroom apartments equipped with modern amenities such as in-unit washers and dryers, making Phillips Pass an ideal choice for students and professionals alike.\n\nLocated in Briar Village, Phillips Pass offers a serene environment with easy access to the Center for Advanced Legal Studies. Residents can take advantage of our top-notch amenities like a well-equipped fitness center and a refreshing pool, perfect for post-class relaxation. Additionally, the community is conveniently located near shopping and dining options, offering a well-rounded living experience. Choose our apartments close to Center for Advanced Legal Studies for the perfect balance of comfort and accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Center for Advanced Legal Studies | Phillips Pass",
      "seo_description": "Discover apartments close to Center for Advanced Legal Studies in Houston, TX at Phillips Pass. Enjoy modern amenities and an excellent location. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-near-the-learning-experience-eldridge-houston-667",
      "search_query": "apartments near The Learning Experience - Eldridge Houston",
      "category": "School",
      "h1_title": "Apartments Near The Learning Experience Eldridge",
      "h2_subtitle": "Explore apartments near The Learning Experience on Eldridge in Houston. Enjoy convenient living at Phillips Pass.",
      "page_copy": "Searching for apartments near The Learning Experience - Eldridge in Houston? Phillips Pass offers a welcoming community perfect for families and professionals. Our spacious one and two-bedroom floor plans are designed with comfort in mind, including modern features like in-unit washers and dryers, stainless steel appliances, and more.\n\nLocated in the vibrant Briar Village neighborhood, Phillips Pass is just moments from The Learning Experience on Eldridge. Enjoy the benefits of living near quality educational facilities, while also taking advantage of our community amenities such as a fitness center, a grilling area, and a sparkling pool. Whether you’re settling down with family or starting a new chapter, our apartments provide the ideal setting. Experience a community that combines convenience and comfort in one.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near The Learning Experience Eldridge | Phillips Pass",
      "seo_description": "Find spacious apartments near The Learning Experience - Eldridge in Houston at Phillips Pass. Perfect for families seeking convenience. Schedule your visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-near-westside-montessori-briar-village-493",
      "search_query": "apartments near Westside Montessori Briar Village",
      "category": "School",
      "h1_title": "Apartments Near Westside Montessori Briar Village",
      "h2_subtitle": "Discover convenient apartments near Westside Montessori in Briar Village. Enjoy family-friendly living at Phillips Pass.",
      "page_copy": "Located close to Westside Montessori in Briar Village, Phillips Pass offers the perfect setting for those seeking family-friendly living in Houston. Our community features spacious one and two-bedroom apartments that cater to modern lifestyles, equipped with features such as stainless steel appliances and in-unit washers and dryers, ensuring a comfortable and convenient living experience.\n\nLiving in Phillips Pass means easy access to Westside Montessori, making school drop-offs and pick-ups seamless. Enjoy our community's array of amenities, including a fitness center and a serene swimming pool, all designed to enhance your lifestyle. Nestled in the charming Briar Village area, our apartments provide a peaceful sanctuary with proximity to educational facilities and local attractions. Experience the convenience and comfort of Phillips Pass today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Westside Montessori Briar Village | Phillips Pass",
      "seo_description": "Find family-friendly apartments near Westside Montessori in Briar Village at Phillips Pass. Enjoy modern amenities and a great location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-close-to-smaller-scholars-montessori-academy-77077-875",
      "search_query": "apartments close to Smaller Scholars Montessori Academy 77077",
      "category": "School",
      "h1_title": "Apartments Close to Smaller Scholars Montessori",
      "h2_subtitle": "Explore convenient apartments close to Smaller Scholars Montessori Academy in the 77077 zip area. Experience quality living at Phillips Pass.",
      "page_copy": "For those seeking apartments close to Smaller Scholars Montessori Academy in the 77077 area, Phillips Pass offers an exceptional living experience. Our one and two-bedroom floor plans are thoughtfully designed to meet the needs of families and individuals alike, featuring modern conveniences such as in-unit washers and dryers and stainless steel appliances.\n\nPhillips Pass's prime location in Briar Village provides easy access to Smaller Scholars Montessori Academy, ensuring school routines are hassle-free. Residents can also enjoy our range of amenities, including a fitness center for active lifestyles and a refreshing pool for relaxation. Nestled in a prime spot, our community combines the tranquility of suburban living with the excitement of nearby shopping and dining options. Choose Phillips Pass for a home that blends comfort with convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Smaller Scholars Montessori 77077 | Phillips Pass",
      "seo_description": "Discover apartments close to Smaller Scholars Montessori Academy in 77077 at Phillips Pass. Enjoy modern living and great amenities. Schedule a visit now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-near-the-briarwood-school-harris-county-344",
      "search_query": "apartments near The Briarwood School Harris County",
      "category": "School",
      "h1_title": "Apartments Near The Briarwood School Harris County",
      "h2_subtitle": "Find convenient apartments near The Briarwood School in Harris County. Discover the comfort of Phillips Pass living.",
      "page_copy": "Looking for apartments near The Briarwood School in Harris County? Phillips Pass provides an ideal living environment with beautifully designed one and two-bedroom floor plans. Each apartment is equipped with modern amenities like stainless steel appliances and in-unit washers and dryers, ensuring a comfortable, hassle-free lifestyle.\n\nLocated in the welcoming Briar Village neighborhood, Phillips Pass offers easy access to The Briarwood School, making daily commutes simple and convenient. Our property boasts a range of amenities, from a fully-equipped fitness center to our inviting swimming pool, perfect for relaxation and recreation. Experience a blend of comfort, convenience, and community by choosing Phillips Pass as your home base in Houston.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near The Briarwood School Harris County | Phillips Pass",
      "seo_description": "Find modern apartments near The Briarwood School in Harris County at Phillips Pass. Enjoy amenities and community living. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-near-the-village-school-houston-79",
      "search_query": "apartments near The Village School Houston",
      "category": "School",
      "h1_title": "Apartments Near The Village School Houston",
      "h2_subtitle": "Discover ideal apartments near The Village School in Houston. Experience quality living at Phillips Pass.",
      "page_copy": "Phillips Pass offers exceptional living spaces for those seeking apartments near The Village School in Houston. Our community is designed with spacious one and two-bedroom options, featuring contemporary conveniences such as stainless steel appliances and in-suite washers and dryers to enhance your living experience.\n\nSituated in the charming Briar Village neighborhood, Phillips Pass provides a strategic location with straightforward access to The Village School, offering simplicity in school commutes. Residents can take advantage of our wide array of amenities, including a modern fitness center and a relaxing swimming pool. Enjoy the best of both worlds—being part of a vibrant community and living near one of Houston's notable educational institutions. Choose Phillips Pass for comfortable and convenient living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near The Village School Houston | Phillips Pass",
      "seo_description": "Explore Phillips Pass for apartments near The Village School in Houston. Enjoy modern amenities and convenient community living. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-near-texas-connections-academy-houston-435",
      "search_query": "apartments near Texas Connections Academy @ Houston",
      "category": "School",
      "h1_title": "Apartments Near Texas Connections Academy",
      "h2_subtitle": "Find the perfect apartment near Texas Connections Academy in Houston. Enjoy modern living at Phillips Pass, designed for your convenience.",
      "page_copy": "Are you searching for apartments near Texas Connections Academy @ Houston? Phillips Pass offers a prime location with spacious floor plans in the heart of Briar Village. Our one and two-bedroom apartments are equipped with modern conveniences such as in-unit washers and dryers, providing a hassle-free living environment.\n\nAt Phillips Pass, residents enjoy easy access to Texas Connections Academy, making school routines smoother and more efficient. Our community boasts an impressive range of amenities including a fitness center for staying active and a pool for unwinding after a long day. Discover the comfort and convenience of living near a reputable educational institution while enjoying all the perks of a modern, community-focused environment at Phillips Pass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Texas Connections Academy Houston | Phillips Pass",
      "seo_description": "Discover Phillips Pass for apartments near Texas Connections Academy in Houston. Experience modern living and great amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-close-to-westchester-academy-tx-745",
      "search_query": "apartments close to Westchester Academy for International Studies TX",
      "category": "School",
      "h1_title": "Apartments Close to Westchester Academy TX",
      "h2_subtitle": "Discover comfortable apartments close to Westchester Academy for International Studies in TX. Enjoy luxurious living at Phillips Pass.",
      "page_copy": "Looking for apartments close to Westchester Academy for International Studies in TX? Phillips Pass offers a superb location with beautiful one and two-bedroom floor plans, making it an excellent choice for families and students alike. Each apartment is thoughtfully designed with modern amenities, including stainless steel appliances and efficient washers and dryers to cater to your daily needs.\n\nNestled in the inviting Briar Village neighborhood, our community provides easy access to Westchester Academy, ensuring convenient commutes. At Phillips Pass, you can indulge in top-notch amenities such as a state-of-the-art fitness center and a refreshing pool. Offering a blend of style, comfort, and convenience, Phillips Pass stands as an ideal home for those wishing to be near Westchester Academy in TX. Experience community living at its finest today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Westchester Academy TX | Phillips Pass",
      "seo_description": "Find Phillips Pass apartments close to Westchester Academy for International Studies in TX. Enjoy modern living and great amenities. Visit us now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-near-holy-spirit-episcopal-school-houston-211",
      "search_query": "apartments near Holy Spirit Episcopal School Houston",
      "category": "School",
      "h1_title": "Apartments Near Holy Spirit Episcopal School",
      "h2_subtitle": "Explore our apartments near Holy Spirit Episcopal School in Houston. Enjoy a premier lifestyle at Phillips Pass.",
      "page_copy": "Phillips Pass is the ideal choice for those searching for apartments near Holy Spirit Episcopal School in Houston. Featuring spacious one and two-bedroom layouts, our community is perfectly designed to meet the needs of families and individuals who value proximity to education.\n\nLocated in the delightful Briar Village neighborhood, Phillips Pass offers convenient access to Holy Spirit Episcopal School, ensuring that school commutes are straightforward and stress-free. Our residents benefit from top-notch amenities like a fitness center, a sparkling pool, and on-site property management. Choose Phillips Pass for a harmonious blend of modern living, convenience, and community-focused amenities, all within easy reach of Holy Spirit Episcopal School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Holy Spirit Episcopal School | Phillips Pass",
      "seo_description": "Looking for apartments near Holy Spirit Episcopal School in Houston? Discover Phillips Pass and enjoy premium living with exceptional amenities. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-near-memorial-private-school-briar-village-191",
      "search_query": "apartments near Memorial Private School Briar Village",
      "category": "School",
      "h1_title": "Apartments Near Memorial Private School",
      "h2_subtitle": "Live close to Memorial Private School in Briar Village. Discover the perfect apartment at Phillips Pass.",
      "page_copy": "Phillips Pass offers an outstanding option for those seeking apartments near Memorial Private School in Briar Village. Our community features expansive one and two-bedroom floor plans, ideal for families and students aiming to live near their educational pursuits. \n\nLocated in the serene Briar Village neighborhood, living at Phillips Pass grants easy access to Memorial Private School, making daily commutes simpler. Residents can take advantage of exceptional community perks such as a modern fitness center, a refreshing pool, and the convenience of on-site management. Experience a harmonious blend of convenience and luxury living close to Memorial Private School at Phillips Pass.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Memorial Private School | Phillips Pass",
      "seo_description": "Explore Phillips Pass for apartments near Memorial Private School in Briar Village. Experience modern amenities and comfortable living. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-close-to-grace-school-77077-800",
      "search_query": "apartments close to Grace School 77077",
      "category": "School",
      "h1_title": "Apartments Close to Grace School 77077",
      "h2_subtitle": "Find your ideal apartment close to Grace School in the 77077 area. Discover comfortable living at Phillips Pass.",
      "page_copy": "Phillips Pass is your go-to choice for apartments close to Grace School in the 77077 area. Offering both one and two-bedroom floor plans, our apartments are ideal for families and educators seeking a convenient location paired with exceptional living facilities.\n\nLocated in the friendly Briar Village neighborhood, Phillips Pass provides seamless access to Grace School, allowing for stress-free commutes. Enjoy amenities including a well-equipped fitness center, a sparkling pool, and the convenience of modern appliances like in-unit washers and dryers. Experience the superb blend of comfort, convenience, and community at Phillips Pass, steps away from Grace School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Grace School 77077 | Phillips Pass",
      "seo_description": "Explore Phillips Pass apartments close to Grace School in 77077, offering modern living and top amenities. Perfect location for families and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5091000275959808",
      "source": "custom",
      "page_item_url": "apartments-near-molo-bilingual-montessori-school-harris-county-926",
      "search_query": "apartments near MOLO Bilingual Montessori School Harris County",
      "category": "School",
      "h1_title": "Apartments Near MOLO Bilingual Montessori School",
      "h2_subtitle": "Explore apartments close to MOLO Bilingual Montessori School in Harris County. Find your new home at Phillips Pass today.",
      "page_copy": "If you're searching for apartments near MOLO Bilingual Montessori School in Harris County, look no further than Phillips Pass. Our community offers spacious one and two-bedroom apartments ideal for families and educators hoping to live in proximity to this remarkable school.\n\nSituated in the welcoming Briar Village neighborhood of Houston, Phillips Pass provides easy access to MOLO Bilingual Montessori School, ensuring a convenient daily commute. Residents at Phillips Pass enjoy amenities such as a state-of-the-art fitness center, a refreshing pool, and new stainless steel appliances in every home. Experience top-tier living where convenience meets modern style, just minutes away from MOLO Bilingual Montessori School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c10-4c68-739b-8b3b-0b99a2b33fcd",
        "storage_key": "property/5091000275959808/019f6c10-4c68-739b-8b3b-0b99a2b33fcd.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near MOLO Bilingual Montessori School | Phillips Pass",
      "seo_description": "Discover apartments near MOLO Bilingual Montessori School in Harris County at Phillips Pass. Enjoy comfort, convenience, and excellent amenities. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2603"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "3391718092"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a41\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a41\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5056159"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MC38PPF"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://phillipspa.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "9835676774"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/m1ywy46owq0"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/6435b085-c14d-46dd-a69b-5a33d87074db"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "346-536-8689"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imh2Ynh1NDNuVXBVMGFweHB2UE1ZRlE9PSIsInZhbHVlIjoiaVZPRVEvb2tOUEdlOG1ORFBYTzJGdz09IiwibWFjIjoiYThhMzI0M2IwNzQ3ZGUzZjhkMDQ0Yjk1MDI0YWZmMjc4N2ZmOTllNzI4NGZiNTUyN2Q0MDk2NTIyMGFmYWI2MSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2603",
  "custom_repli_id": "3391718092",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a41\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a41\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5056159",
  "custom_google_gtm_id": "GTM-MC38PPF",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://phillipspa.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "9835676774",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/m1ywy46owq0",
  "custom_self_guided_tour_url": "https://selftournow.com/property/6435b085-c14d-46dd-a69b-5a33d87074db",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "346-536-8689",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imh2Ynh1NDNuVXBVMGFweHB2UE1ZRlE9PSIsInZhbHVlIjoiaVZPRVEvb2tOUEdlOG1ORFBYTzJGdz09IiwibWFjIjoiYThhMzI0M2IwNzQ3ZGUzZjhkMDQ0Yjk1MDI0YWZmMjc4N2ZmOTllNzI4NGZiNTUyN2Q0MDk2NTIyMGFmYWI2MSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "1a7d7dbd-6917-4da4-8faa-0e167e66a663",
  "custom_audioeye_site_hash": "04b34b1d83ac6851eb2118e58099ded9"
};

export const generatedAt = '2026-11-03T20:32:55.589Z';
